var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_cat-cheff"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M116 130c0 27.06 22.086 49 49.331 49H264V80.998C264 53.937 241.914 32 214.666 32H116v98zm97.095.942h-49.018v-49h49.019v49h-.001z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205,
    cy: 268.5,
    fill: "#81D39D",
    rx: 205,
    ry: 20.5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#81D39D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.255 274c-7.418-23.223-11.128-37.167-11.128-41.832 0-6.997-2.769-12.622-5.57-17.058-2.802-4.434-2.802-14.906 1.384-19.09 4.186-4.182 9.359-1.405 11.328 3.139 1.97 4.542 4.986 13.905 4.986 23.577 0 9.67 4.492 16.404 4.492 20.936 0 3.022 1.73 13.13 5.188 30.328h-10.68zm-.674 0c-10.333-19.25-15.72-32.006-16.157-38.264-.657-9.387-7.37-13.06-7.37-18.069 0-5.008-4.658-9.872-9.274-9.565-4.616.305-6.016 4.138-4.409 8.502 1.037 2.82 2.088 11.911 4.41 18.826 1.272 3.787 4.615 7.747 4.615 7.747s2.661 2.28 4.659 6.07c1.77 3.358 5.632 11.608 11.586 24.753h11.94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.548 273.987c-1.732-13.148-4.61-21.195-8.638-24.143-6.041-4.424-7.946-9.101-12.227-8.785-4.281.316-5.58 4.276-4.09 8.785.963 2.913 3.006 6.017 5.16 13.161 1.18 3.913 7.02 10.995 7.02 10.995l12.775-.013zm39.742 0c1.54-13.148 4.1-21.195 7.678-24.143 5.371-4.424 7.065-9.101 10.87-8.785 3.804.316 4.96 4.276 3.635 8.785-.856 2.913-2.673 6.017-4.586 13.161C92.838 266.918 87.645 274 87.645 274l-11.355-.013zM61.408 274c1.903-15.155 2.855-24.623 2.855-28.4 0-5.665-8.79-67.951-8.79-77.418 0-9.467 1.993-18.405 6.367-21.794 4.374-3.387 13.359-1.933 11.99 19.986-.623 9.982 5.3 66.009 5.3 71.108 0 5.333-1.37 9.636-1.37 12.326 0 3.506-.838 11.57-2.514 24.192H61.408z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#4C85FF",
    transform: "translate(116 169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.227 2.163C56.019.72 39.19 0 26.74 0 13.002 0 5.25 3.405 4.26 3.958c-2.07 1.155 0 3.391 0 6.292 0 5.18 3.246 7.097 9.739 5.75 2.21.597 3.877.806 5 .627 5.013-.798 4.061-2.74 5-2.533.955.21 29.984 6.322 53.227 12.673V2.163z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.122,
    cy: 8.03,
    rx: 4.451,
    ry: 4.461
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4379EC",
    d: "M312 274c9.703-.72 10.74-.506 13.106-3.361 18.004-21.714 6.11-47.416 0-81.02-3.616-19.889 16.231-19.889 25.142-16.857C371.196 179.888 424 160.948 424 95.219 424 26.688 362.75 7 325.106 7c-37.645 0-96.762 22.006-105.924 83.736-6.88 46.344 16.279 101.42 69.473 165.23L307 270.64 312 274z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C85FF",
    d: "M179.052 75.411c-2.668 0-16.803 47.008-24.332 96.723-.875 5.774-1.326 37.7-2.038 46.715-1.428 18.082-4.908 26.03-5.682 57.151l145.939-.446h39.41c2.235 0 0-56.701-27.573-98.606C274.914 131.565 221.047 71 218.379 71c-1.779 0-6.093 3.823-12.945 11.469l-13.339.763c-6.917-5.214-11.264-7.82-13.043-7.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4379EC",
    d: "M221.45 125.265c11.78 1.364 5.104-10.403 5.104-15.088 0-4.687 0-15.177-12.962-15.177-12.96 0-12.173 10.77-12.173 15.455 0 4.687 8.25 13.447 20.032 14.81zm45.51 131.626c-11.78 1.363-5.104-10.404-5.104-15.09s0-15.176 12.962-15.176c12.96 0 12.173 10.77 12.173 15.455 0 4.686-8.25 13.447-20.031 14.81zm-77.92-64.388c11.781 1.363 5.104-10.403 5.104-15.09 0-4.685 0-15.176-12.961-15.176-12.962 0-12.174 10.77-12.174 15.456s8.252 13.446 20.032 14.81zm36.212 40.269c-31.327 5.757-15.585-26.185-16.442-38.41-.858-12.223-2.778-39.588 31.965-42.009 34.742-2.42 37.207 25.966 35.46 38.044-1.748 12.079-19.655 36.617-50.983 42.375z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189 105)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.888,
    cy: 4.922,
    fill: "#FFF",
    rx: 4.888,
    ry: 4.922
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.333,
    cy: 6.369,
    fill: "#3C3C58",
    rx: 1.778,
    ry: 1.79
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.997,
    cy: 4.922,
    fill: "#FFF",
    rx: 4.888,
    ry: 4.922
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.665,
    cy: 6.369,
    fill: "#3C3C58",
    rx: 1.778,
    ry: 1.79
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F77676",
    d: "M198.769 116.645l6.284-.64a.864.864 0 0 1 .845.433.814.814 0 0 1-.093.924l-2.815 3.333a.875.875 0 0 1-1.198.123l-3.47-2.694a.819.819 0 0 1-.287-.885.851.851 0 0 1 .733-.594h.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9BBBFF",
    d: "M182.272 80.474l3.664 2.272c.587.365.892 1.043.772 1.716a1.694 1.694 0 0 1-1.318 1.354l-5.32 1.145a1.72 1.72 0 0 1-1.702-.6 1.665 1.665 0 0 1-.2-1.772l1.655-3.416a1.7 1.7 0 0 1 1.066-.891 1.727 1.727 0 0 1 1.384.192zm35.109-3.04l-3.095 2.764a1.668 1.668 0 0 0-.47 1.791c.22.636.802 1.082 1.481 1.135l6.86.535a1.71 1.71 0 0 0 1.706-1.019 1.668 1.668 0 0 0-.437-1.919l-3.766-3.296a1.725 1.725 0 0 0-2.28.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C85FF",
    d: "M301.459 63.793c13.513-7.32 16.442-26.617 13.028-31.474-3.414-4.855-20.537-10.359-41.947 12.469-10.643 11.346-10.944 19.78-7.796 24.865 3.186 5.145 23.202 1.459 36.715-5.86zm53.15 74.183c-18.18-7.15 11.778-25.714 0-42.347-4.838-6.834-21.863-6.216-21.863-26.78 0-10.316 19.998-17.3 36.186-12.15 16.08 5.114 26.242 17.972 28.35 30.549 6.027 35.961-27.428 56.723-42.672 50.728z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#81D39D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.65 280c4.045-12.728 6.068-20.37 6.068-22.927 0-3.835 1.511-6.919 3.04-9.35 1.528-2.43 1.528-8.17-.755-10.462-2.284-2.292-5.106-.77-6.18 1.72-1.074 2.49-2.72 7.621-2.72 12.922 0 5.3-2.449 8.991-2.449 11.475 0 1.656-.943 7.196-2.83 16.622h5.826z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.47 280c5.653-10.358 8.6-17.222 8.84-20.59.36-5.05 4.03-7.027 4.03-9.723 0-2.694 2.549-5.311 5.075-5.146 2.524.164 3.29 2.227 2.412 4.575-.568 1.517-1.143 6.41-2.413 10.13-.695 2.038-2.525 4.168-2.525 4.168s-1.456 1.228-2.548 3.267c-.969 1.807-3.081 6.246-6.339 13.319h-6.531z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.883 279.993c.956-7.074 2.547-11.405 4.773-12.992 3.338-2.38 4.39-4.896 6.756-4.726 2.366.17 3.083 2.3 2.26 4.726-.532 1.569-1.661 3.24-2.851 7.083-.652 2.105-3.88 5.916-3.88 5.916l-7.059-.007zm-21.647 0c-.83-7.074-2.21-11.405-4.138-12.992-2.893-2.38-3.805-4.896-5.856-4.726-2.05.17-2.671 2.3-1.958 4.726.46 1.569 1.44 3.24 2.47 7.083.567 2.105 3.363 5.916 3.363 5.916l6.119-.007zm7.988.007c-1.06-8.224-1.59-13.361-1.59-15.411 0-3.074 4.895-36.873 4.895-42.01 0-5.137-1.11-9.987-3.546-11.825-2.436-1.839-7.44-1.05-6.678 10.845.347 5.416-2.952 35.817-2.952 38.585 0 2.894.762 5.23.762 6.688 0 1.903.467 6.28 1.401 13.128h7.708z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 243,
    cy: 8,
    r: 8,
    fill: "#B5FECE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147,
    cy: 2,
    r: 2,
    fill: "#4C85FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 192,
    r: 2,
    fill: "#4C85FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 50,
    r: 2,
    fill: "#4C85FF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71 48)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.163,
    cy: 10.5,
    fill: "#CFDEFF",
    rx: 10.163,
    ry: 10.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5,
    cy: 10.977,
    fill: "#4C85FF",
    rx: 2.282,
    ry: 2.386
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 324,
    cy: 114,
    r: 12,
    fill: "#4C85FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 241,
    r: 6,
    fill: "#4379EC"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#CFDEFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.448 67.558l32.889-11.97c3.278 3.723 5.469 7.1 6.572 10.13 1.103 3.03 2.005 8.69 2.708 16.98-5.977 6.3-11.706 10.448-17.188 12.443-5.481 1.995-10.215 2.326-14.201.993-4.807-7.273-7.874-12.733-9.202-16.38-1.327-3.647-1.853-7.712-1.578-12.196z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.297 69.787c.62-6.097 5.072-8.827 12.503-11.207 8.38-2.683 9.724-.93 20.994-4.056 5.95-1.651 13.444-8.963 16.925-9.01 9.908-.136 12.635 4.987 10.533 10.93-1.275 3.604-1.126 5.618-6.247 9.123-8.435 5.773-14.86 5.544-28.3 8.57-8.172 1.84-6.381 6.232-11.861 6.307-4.342.059-4.014-1.848-9.033-2.058-6.808-.284-5.907-4.743-5.514-8.599z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117 109)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#81D39D",
    d: "M14 24.091h67a6 6 0 0 1 6 6v37H8v-37a6 6 0 0 1 6-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#62C284",
    d: "M8 39.091h79v19H8z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 3,
    y: 67.091,
    fill: "#F1F1F1",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F77676",
    d: "M38.464 8.22c3.453-4.753 6.571-5.866 9.523-5.776 2.952.09 6.841 3.384 8.509 7.97 1.667 4.586 5.388 8.488 3.029 11.306-2.359 2.819-8.821 2.886-13.465 1.983-4.644-.902-9.119-2.951-9.92-5.943-.802-2.991-1.13-4.787 2.324-9.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#81D39D",
    d: "M33.503 2.897c2.438.377 5.096 3.674 5.872 3.227 5.36-3.09 6.222-7.503 12.75-3.573 1.346.81 3.962 4.856 2.564 4.122-2.433-1.279-4.762-3.555-6.824-2.895l-3.3 1.352c-2.07.663.56 1.58 2.52 3.595 1.96 2.016 2.032 4.634 1.66 4.657-3.725.228-3.048-.612-4.552-1.371-2.31-1.166-4.472-1.623-4.818-.389-.48 1.707.53 2.392-.608 5.343-.549 1.423.989 5.696 0 4.532-1.069-1.257-3.47-3.108-3.541-6.054-.07-2.885 2.17-6.87 2.87-7.61-3.552-.958-5.25-1.65-5.096-2.078.264-.732-1.936-3.235.503-2.858z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E46969",
    d: "M46.809 16.488c.447.325.94.407 1.103.183.162-.223-.357-.652-.804-.977-.447-.324-.652-.422-.814-.198-.162.223.068.667.515.992zM47.278 21.696c-.522-.18-1.025-.393-1.115-.132-.09.261.26.618.783.798.522.18 1.063.192 1.108-.147.045-.34-.253-.34-.776-.52zM51.985 21.25c.544.095 1.272-.069 1.32-.34.048-.272-.69-.23-1.233-.326-.544-.096-.937-.272-.985 0-.048.271.354.57.898.666zM56.567 18.693c-.447-.325-.913-.397-1.075-.173-.162.223.13.538.576.863.447.324.967.805 1.13.582.162-.224-.184-.948-.631-1.272zM53.5 14.457c.276.478.694.754.933.616.24-.138.21-.638-.067-1.116-.276-.478-.984-.67-1.223-.531-.239.138.08.553.357 1.031zM40.891 17.697c.513.207 1.122.207 1.122-.21 0-.418-.419-.425-.93-.632-.513-.207-.796-.43-.9-.175-.103.257.196.81.708 1.017zM50.409 8.734c-.423-.355-.91-.471-1.088-.26-.177.212.067.288.49.643.423.355.865.854 1.042.643.178-.212-.021-.671-.444-1.026z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 179,
    r: 5,
    fill: "#4C85FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 121,
    cy: 177.5,
    fill: "#4C85FF",
    rx: 4,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 180,
    r: 5,
    fill: "#4C85FF"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icon_cat-services"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(15 12)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M135 151.999c0 31.48 25.668 57.001 57.331 57.001H307V94.998C307 63.518 281.332 38 249.666 38H135v113.999zm112.84 1.097h-56.967v-57h56.968v57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    fillRule: "nonzero",
    d: "M77.565 144.852a2.203 2.203 0 0 1-.723-4.349c24.561-4.088 37.757.095 38.025 13.37.23 11.423.161 26.078-.206 43.968a2.204 2.204 0 1 1-4.406-.09c.366-17.836.435-32.434.206-43.79-.192-9.503-10.636-12.814-32.896-9.109z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 239,
    cy: 313,
    fill: "#81D39D",
    rx: 239,
    ry: 24
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F77676",
    d: "M65.146 155.111h-9.368a2.778 2.778 0 1 1 0-5.555h9.368v-13.334h-9.368a2.778 2.778 0 1 1 0-5.555h9.368V124h14.229c9.518 0 17.483 6.649 19.504 15.556h3.232a3.889 3.889 0 1 1 0 7.777h-3.013C97.512 156.793 89.285 164 79.375 164h-14.23v-8.889z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M25 37h35v276H25z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#81D39D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.136 320c-8.598-27.184-12.898-43.505-12.898-48.966 0-8.19-3.209-14.775-6.457-19.967-3.247-5.191-3.247-17.448 1.605-22.345 4.852-4.896 10.848-1.645 13.13 3.673 2.283 5.317 5.78 16.277 5.78 27.598 0 11.32 5.206 19.202 5.206 24.507 0 3.537 2.005 15.37 6.014 35.5h-12.38zM62.355 320c-11.977-22.534-18.22-37.464-18.727-44.79-.762-10.988-8.542-15.287-8.542-21.15 0-5.862-5.4-11.556-10.75-11.197-5.35.358-6.973 4.844-5.11 9.953 1.202 3.301 2.42 13.942 5.11 22.036 1.475 4.433 5.35 9.068 5.35 9.068s3.085 2.67 5.4 7.106c2.051 3.93 6.528 13.587 13.43 28.974h13.839z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.613 319.985c-2.008-15.39-5.345-24.81-10.013-28.261-7.002-5.178-9.21-10.653-14.172-10.283-4.962.37-6.467 5.005-4.74 10.283 1.115 3.41 3.484 7.044 5.98 15.406 1.367 4.58 8.138 12.87 8.138 12.87l14.807-.015zM88.677 319.985c1.785-15.39 4.752-24.81 8.9-28.261 6.225-5.178 8.188-10.653 12.598-10.283 4.41.37 5.749 5.005 4.214 10.283-.992 3.41-3.098 7.044-5.316 15.406-1.215 4.58-7.234 12.87-7.234 12.87l-13.162-.015zM71.427 320c2.206-17.74 3.31-28.822 3.31-33.243 0-6.632-10.189-79.54-10.189-90.622 0-11.081 2.31-21.543 7.38-25.51 5.07-3.965 15.484-2.263 13.898 23.394-.723 11.685 6.142 77.266 6.142 83.235 0 6.243-1.586 11.28-1.586 14.428 0 4.104-.972 13.543-2.915 28.318h-16.04z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(125 184)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4C85FF",
    d: "M92.101 2.483C67.447.828 47.884 0 33.411 0 17.44 0 8.43 3.91 7.278 4.544c-2.406 1.327 0 3.894 0 7.224 0 8.922 5.978 8.64 10.162 8.64 14.513 0 14.513-5.344 15.971-5.028 6.127 1.33 25.69 6.447 58.69 15.352V2.483z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.279,
    cy: 9.22,
    fill: "#4C85FF",
    rx: 5.174,
    ry: 5.122
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C85FF",
    d: "M3.782 8.195c-2.046 0-4.187 4.168-3.716 4.87.77 1.151.77-2.006 3.716-2.246.497-.04 1.626.709 3.386 2.246.145-1.824.082-2.991-.19-3.501-.665-1.247-2.35-1.369-3.196-1.369z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFC1BE",
    transform: "translate(11.383 14.341)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.753,
    cy: 1.887,
    rx: 3.375,
    ry: 1.402
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.998,
    cy: 2.076,
    rx: 2.455,
    ry: 1.051
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#4379EC",
    d: "M357.576 321.957c11.313-.84 18.349-2.925 21.108-6.257 20.991-25.343 7.125-55.34 0-94.56-4.216-23.213 18.924-23.213 29.313-19.675 24.423 8.317 85.987-13.788 85.987-90.502C493.984 30.978 422.574 8 378.684 8S265.87 33.684 255.188 105.73c-8.02 54.09 18.98 118.371 80.998 192.845l21.39 23.382z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C85FF",
    d: "M208.683 88.25c-3.104 0-21.922 64.088-30.683 122.14-3.058 20.266-5.262 57.629-6.611 112.088l169.806-.521h45.856c2.6 0 0-66.21-32.083-115.142-34.745-52.994-97.422-123.716-100.526-123.716-2.07 0-7.09 4.464-15.063 13.392l-15.52.891c-8.048-6.088-13.106-9.132-15.176-9.132z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4379EC",
    d: "M257.959 145.967c13.725 1.591 5.946-12.136 5.946-17.602 0-5.467 0-17.705-15.102-17.705-15.101 0-14.183 12.564-14.183 18.03 0 5.467 9.613 15.686 23.339 17.277zM310.983 299.519c-13.725 1.59-5.946-12.137-5.946-17.603 0-5.467 0-17.705 15.102-17.705 15.101 0 14.183 12.564 14.183 18.03 0 5.467-9.613 15.687-23.339 17.278zM220.197 224.405c13.726 1.59 5.946-12.136 5.946-17.603 0-5.466 0-17.704-15.101-17.704-15.102 0-14.184 12.564-14.184 18.03 0 5.467 9.614 15.686 23.34 17.277zM262.388 271.382c-36.5 6.716-18.158-30.547-19.157-44.807-1-14.26-3.237-46.184 37.243-49.008 40.48-2.824 43.352 30.292 41.316 44.382-2.036 14.09-22.901 42.716-59.402 49.433z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(220.175 122.471)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.67,
    cy: 5.906,
    fill: "#FFF",
    rx: 5.67,
    ry: 5.906
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.186,
    cy: 6.443,
    fill: "#3C3C58",
    rx: 2.062,
    ry: 2.148
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.197,
    cy: 5.906,
    fill: "#FFF",
    rx: 5.67,
    ry: 5.906
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.651,
    cy: 6.443,
    fill: "#3C3C58",
    rx: 2.062,
    ry: 2.148
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F77676",
    d: "M231.193 135.602l7.33-.769a1 1 0 0 1 .877 1.63l-3.283 4.003a1 1 0 0 1-1.398.147l-4.047-3.235a1 1 0 0 1 .52-1.776z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9BBBFF",
    d: "M212.096 93.762l4.293 2.7a2 2 0 0 1-.64 3.647l-6.232 1.36a2 2 0 0 1-2.23-2.818l1.94-4.058a2 2 0 0 1 2.87-.83zM253.23 90.152l-3.626 3.283a2 2 0 0 0 1.185 3.476l8.037.635a2 2 0 0 0 1.486-3.49L255.9 90.14a2 2 0 0 0-2.67.013z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C85FF",
    d: "M351.716 74.098c15.694-8.542 19.095-31.065 15.13-36.733-3.964-5.667-23.85-12.09-48.715 14.552-12.36 13.242-12.71 23.087-9.053 29.021 3.7 6.005 26.945 1.702 42.638-6.84zM413.443 160.678c-21.115-8.345 13.677-30.011 0-49.423-5.62-7.976-25.392-7.255-25.392-31.255 0-12.04 23.225-20.192 42.025-14.182 18.675 5.97 30.476 20.976 32.924 35.655 7 41.971-31.853 66.202-49.557 59.205z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#81D39D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.758 326c4.72-14.91 7.08-23.863 7.08-26.857 0-4.493 1.763-8.105 3.546-10.953 1.783-2.847 1.783-9.57-.881-12.256-2.664-2.685-5.956-.902-7.209 2.015-1.253 2.916-3.173 8.928-3.173 15.137 0 6.21-2.858 10.533-2.858 13.442 0 1.94-1.1 8.43-3.302 19.472h6.797z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.549 326c6.595-12.134 10.032-20.174 10.312-24.119.42-5.917 4.703-8.232 4.703-11.39 0-3.156 2.973-6.222 5.92-6.029 2.945.193 3.839 2.609 2.814 5.36-.663 1.777-1.333 7.508-2.815 11.866-.811 2.387-2.946 4.883-2.946 4.883s-1.698 1.438-2.973 3.827c-1.13 2.116-3.594 7.316-7.395 15.602h-7.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.53 325.992c1.116-8.287 2.972-13.36 5.569-15.219 3.894-2.788 5.122-5.736 7.882-5.537 2.76.2 3.597 2.695 2.637 5.537-.621 1.837-1.939 3.794-3.327 8.297-.76 2.466-4.526 6.93-4.526 6.93l-8.236-.008zM286.275 325.992c-.968-8.287-2.577-13.36-4.827-15.219-3.375-2.788-4.44-5.736-6.832-5.537-2.391.2-3.117 2.695-2.285 5.537.538 1.837 1.68 3.794 2.883 8.297.66 2.466 3.923 6.93 3.923 6.93l7.138-.008zM295.595 326c-1.238-9.634-1.856-15.652-1.856-18.053 0-3.601 5.712-43.194 5.712-49.211 0-6.018-1.295-11.7-4.137-13.853-2.843-2.154-8.681-1.23-7.792 12.704.405 6.345-3.444 41.958-3.444 45.2 0 3.39.89 6.126.89 7.835 0 2.229.544 7.355 1.634 15.378h8.993z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 283.5,
    cy: 9.5,
    r: 9.5,
    fill: "#B5FECE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.5,
    cy: 2.5,
    r: 2.5,
    fill: "#4C85FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.5,
    cy: 223.5,
    r: 2.5,
    fill: "#4C85FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 58.5,
    r: 2.5,
    fill: "#4C85FF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    fillRule: "nonzero",
    d: "M104.5 298.99a2.5 2.5 0 0 1 5 .02c-.04 9.4 1.821 14.188 6.389 17.522 8.221 6 20.838 6.102 40.836 1.861 2.955-.626 5.895-1.3 10.158-2.31 19.06-4.517 24.173-5.51 31.073-5.361 14.965.324 27.415 2.044 43.482 5.418 2.213.465 9.867 2.118 9.271 1.99 3.522.754 6.067 1.273 8.493 1.72 6.022 1.108 10.803 1.65 15.273 1.65 14.482 0 24.169-1.704 38.024-5.762.564-.165 1.134-.334 1.902-.56l.944-.28.942-.279c1.522-.45 2.65-.777 3.759-1.091 9.149-2.587 15.962-3.754 24.32-3.754 8.497 0 12.772.974 18.549 3.56a210.556 210.556 0 0 1 1.007.454c.406.183.705.316 1.002.447 5.83 2.565 11.328 3.739 22.373 3.995 7.123.166 11.319-.52 16.801-2.254.204-.064 1.989-.637 2.517-.802 3.868-1.204 6.726-1.724 10.613-1.705 2.5.012 4.971.26 7.709.735 1.371.238 2.786.528 4.526.917.938.21 4.197.964 4.6 1.056 9.457 2.153 16.239 2.953 25.806 2.451a2.5 2.5 0 1 1 .262 4.993c-10.091.53-17.308-.322-27.178-2.57-.419-.094-3.665-.845-4.582-1.05a89.639 89.639 0 0 0-4.29-.87c-2.479-.431-4.678-.652-6.878-.662-3.312-.017-5.685.416-9.102 1.48-.503.156-2.273.724-2.495.794-5.979 1.891-10.714 2.665-18.425 2.486-11.685-.272-17.827-1.583-24.27-4.417-.313-.138-.624-.277-1.042-.465l-.503-.227-.495-.222c-5.153-2.308-8.737-3.124-16.505-3.124-7.834 0-14.217 1.093-22.96 3.565a328.705 328.705 0 0 0-4.641 1.353l-.946.28-1.915.564c-14.274 4.181-24.408 5.964-39.429 5.964-4.817 0-9.882-.574-16.178-1.733-2.483-.457-5.07-.984-8.635-1.748.583.125-7.055-1.525-9.251-1.986-15.79-3.315-27.953-4.996-42.564-5.312-6.27-.136-11.318.845-29.811 5.228-4.298 1.018-7.271 1.699-10.273 2.335-21.33 4.523-35.058 4.414-44.822-2.713-6.034-4.404-8.487-10.716-8.441-21.582z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(82 56)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.099,
    cy: 12,
    fill: "#CFDEFF",
    rx: 12.099,
    ry: 12
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.5,
    cy: 12.545,
    fill: "#4C85FF",
    rx: 2.717,
    ry: 2.727
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 133,
    r: 14,
    fill: "#4C85FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203,
    cy: 281,
    r: 7,
    fill: "#4379EC"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "icon_user"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,14a6,6,0,1,1,6-6A6,6,0,0,1,12,14ZM12,3a5,5,0,1,0,5,5A5,5,0,0,0,12,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.58,21.56a.5.5,0,0,1-.5-.5,4.05,4.05,0,0,0-4-4H8a4,4,0,0,0-4,4,.5.5,0,0,1-1,0,5,5,0,0,1,5-5h8a5.05,5.05,0,0,1,5,5A.5.5,0,0,1,20.58,21.56Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "icon_home"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ae8d7dd0-f0c3-4f67-ac26-416d06b854cc",
    d: "M18.48,20H5.5A2.5,2.5,0,0,1,3,17.51V11.84a2.52,2.52,0,0,1,.76-1.79l.35.36-.35-.36,6.49-6.33a2.52,2.52,0,0,1,3.5,0l6.48,6.33A2.55,2.55,0,0,1,21,11.84v5.67A2.5,2.5,0,0,1,18.48,20Zm-14-9.24A1.5,1.5,0,0,0,4,11.84v5.67A1.5,1.5,0,0,0,5.5,19h13a1.5,1.5,0,0,0,1.5-1.5V11.84a1.53,1.53,0,0,0-.45-1.07L13.05,4.43a1.52,1.52,0,0,0-2.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae8d7dd0-f0c3-4f67-ac26-416d06b854cc",
    d: "M14,20H10V15a2,2,0,1,1,4,0Zm-3-1h2V15a1,1,0,1,0-2,0Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "icon_menu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 11h20v2H2zM2 5h20v2H2zM2 17h20v2H2z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "icon_login"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 13a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm0 1a6 6 0 1 1 0-12 6 6 0 0 1 0 12zm-8 7.063a.5.5 0 1 1-1 0 5.043 5.043 0 0 1 5.042-5.043h7.991a5.043 5.043 0 0 1 5.043 5.043.5.5 0 1 1-1 0 4.043 4.043 0 0 0-4.043-4.043H8.042a4.043 4.043 0 0 0-4.043 4.043z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "icon_message"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ba9fc5f9-19c6-4378-af66-69f73e2d4483",
    d: "M23.5,27H8.5A5.51,5.51,0,0,1,3,21.5v-9A5.51,5.51,0,0,1,8.5,7h15A5.51,5.51,0,0,1,29,12.5v9A5.51,5.51,0,0,1,23.5,27ZM8.5,8A4.51,4.51,0,0,0,4,12.5v9A4.51,4.51,0,0,0,8.5,26h15A4.51,4.51,0,0,0,28,21.5v-9A4.51,4.51,0,0,0,23.5,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ba9fc5f9-19c6-4378-af66-69f73e2d4483",
    d: "M5.41,25.54,4.59,25l6.65-9.3L4.64,9l.72-.71,7.19,7.25v0l.87.88a3.53,3.53,0,0,0,4.93,0l8.46-8.2.69.71-6.7,6.5L27.55,25l-.81.58L20.07,16.2l-1,1a4.51,4.51,0,0,1-6.33-.07L12,16.38Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ba9fc5f9-19c6-4378-af66-69f73e2d4483",
    cx: 21,
    cy: 23,
    r: 1
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "icon_collapse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5000161,14.5432808 L18.1847198,9.11195907 C18.3990377,8.93782572 18.7139397,8.97040179 18.8880731,9.18471976 C19.0622064,9.39903772 19.0296303,9.71393972 18.8153124,9.88807307 L11.5000161,15.8317513 L4.18471976,9.88807307 C3.97040179,9.71393972 3.93782572,9.39903772 4.11195907,9.18471976 C4.28609241,8.97040179 4.60099442,8.93782572 4.81531238,9.11195907 L11.5000161,14.5432808 Z",
    id: "Page-1-Copy-21"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "icon_close"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13L21 22L22 21L13 12L22 3.00001L21 2.00001L12 11L3.00002 2L2.00002 3L11 12L2 21L3 22L12 13Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "icon_org"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9491663,21.8374426 C49.9491663,21.4039076 49.5923788,21.04712 49.1588437,21.04712 L13.9592679,21.04712 C13.5257328,21.04712 13.1689453,21.4039076 13.1689453,21.8374426 L13.1689453,48.1998811 C13.1689453,48.6334162 13.5257328,48.9902037 13.9592679,48.9902037 L49.1588437,48.9902037 C49.5923788,48.9902037 49.9491663,48.6334162 49.9491663,48.1998811 L49.9491663,21.8374426 Z M49.1588437,49.9902037 L13.9592679,49.9902037 C12.9734481,49.9902037 12.1689453,49.1857009 12.1689453,48.1998811 L12.1689453,21.8374426 C12.1689453,20.8516228 12.9734481,20.04712 13.9592679,20.04712 L49.1588437,20.04712 C50.1446635,20.04712 50.9491663,20.8516228 50.9491663,21.8374426 L50.9491663,48.1998811 C50.9491663,49.1857009 50.1446635,49.9902037 49.1588437,49.9902037 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9888355,20.4958339 C24.9888355,20.7719763 24.7649779,20.9958339 24.4888355,20.9958339 C24.2126931,20.9958339 23.9888355,20.7719763 23.9888355,20.4958339 L23.9888355,16.9364289 C23.9888355,15.9506091 24.7933383,15.1461064 25.7791581,15.1461064 L37.1970451,15.1461064 C38.1828649,15.1461064 38.9873677,15.9506091 38.9873677,16.9364289 L38.9873677,20.4958339 C38.9873677,20.7719763 38.7635101,20.9958339 38.4873677,20.9958339 C38.2112253,20.9958339 37.9873677,20.7719763 37.9873677,20.4958339 L37.9873677,16.9364289 C37.9873677,16.5028939 37.6305802,16.1461064 37.1970451,16.1461064 L25.7791581,16.1461064 C25.345623,16.1461064 24.9888355,16.5028939 24.9888355,16.9364289 L24.9888355,20.4958339 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7039126,32.9579448 C12.4277702,32.9579448 12.2039126,32.7340872 12.2039126,32.4579448 C12.2039126,32.1818024 12.4277702,31.9579448 12.7039126,31.9579448 L28.1212903,31.9579448 C28.3974327,31.9579448 28.6212903,32.1818024 28.6212903,32.4579448 C28.6212903,32.7340872 28.3974327,32.9579448 28.1212903,32.9579448 L12.7039126,32.9579448 Z",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2258065,32.9699156 C34.9496641,32.9699156 34.7258065,32.7460579 34.7258065,32.4699156 C34.7258065,32.1937732 34.9496641,31.9699156 35.2258065,31.9699156 L49.9492188,31.9699156 C50.2253611,31.9699156 50.4492188,32.1937732 50.4492188,32.4699156 C50.4492188,32.7460579 50.2253611,32.9699156 49.9492188,32.9699156 L35.2258065,32.9699156 Z",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4939544,35.0193209 C28.217812,35.0193209 27.9939544,34.7954633 27.9939544,34.5193209 L27.9939544,29.4859445 C27.9939544,29.2098021 28.217812,28.9859445 28.4939544,28.9859445 L34.5173778,28.9859445 C34.7935202,28.9859445 35.0173778,29.2098021 35.0173778,29.4859445 L35.0173778,34.5193209 C35.0173778,34.7954633 34.7935202,35.0193209 34.5173778,35.0193209 L28.4939544,35.0193209 Z M34.0173778,34.0193209 L34.0173778,29.9859445 L28.9939544,29.9859445 L28.9939544,34.0193209 L34.0173778,34.0193209 Z",
    id: "Stroke-9"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "icon_checkbox"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.181417,15.2378252 L17.608161,7.6502538 C17.8013205,7.4529114 18.1178848,7.44952049 18.3152272,7.64267998 C18.5125696,7.83583948 18.5159605,8.15240381 18.322801,8.3497462 L10.1712222,16.6778488 L6.63776393,12.9641147 C6.44741787,12.7640573 6.4552905,12.4475727 6.65534795,12.2572266 C6.85540541,12.0668806 7.17189,12.0747532 7.36223607,12.2748107 L10.181417,15.2378252 Z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "icon_ok"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M12.614 21.437L24.864 7.99a1.5 1.5 0 0 1 2.218 2.02L12.694 25.804l-6.765-6.9a1.5 1.5 0 0 1 2.142-2.1l4.543 4.633z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon_success"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    style: {
      fill: "#4dc738"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.12,44.78,48.37,31.34a1.5,1.5,0,1,1,2.22,2L36.2,49.15l-6.76-6.9a1.5,1.5,0,0,1,2.14-2.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon_error"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    style: {
      fill: "#e40134"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,41l9,9,1-1-9-9,9-9-1-1-9,9-9-9-1,1,9,9-9,9,1,1Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon_question"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    style: {
      fill: "#38b6eb"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(32.69 50.57)",
    style: {
      fontSize: 36,
      fill: "#fff",
      fontFamily: "SymbolMT, Symbol"
    }
  }, "?")), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "icon_back"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ab52d9a4-3c32-4bc2-b5f0-a45629c4b63b",
    d: "M9.37,12.42,14.8,19.1a.5.5,0,1,1-.77.63L8.08,12.42,14,5.1a.49.49,0,0,1,.7-.07.49.49,0,0,1,.07.7Z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "icon_add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aa799c5d-7140-48da-9f4a-fba57abae6cf",
    d: "M46.09,30.59h.17a1.41,1.41,0,0,1,0,2.8H17.91a1.41,1.41,0,0,1,0-2.82H46.09Zm-21.75,0h0ZM18.09,33.4h0Zm15.32-2.81V17.91a1.41,1.41,0,1,0-2.82,0V30.59h2.82Zm12.68,2.82H33.41V46.09a1.41,1.41,0,1,1-2.82,0V33.41Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "icon_settings"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e129e516-4322-4985-9ccd-15b0cd1faa41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a3b46dfc-64c3-4752-aa79-a11fc916e09d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ea0f3545-17bd-4439-8e78-3e7851311809",
    d: "M6.21,19.83V15.35a1,1,0,0,1,.19-.58l7.73-11a1,1,0,0,1,.65-.42,1,1,0,0,1,.74.17L18.8,5.77a1,1,0,0,1,.25,1.4l-7.71,11a1,1,0,0,1-.56.39ZM15,4.3,7.21,15.35v3.16l3.31-.91,7.71-11Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "afac3ede-3c30-4e87-8db5-fcb2fd5d64c4",
    className: "b28bf427-9fea-4ccf-8bda-1edddbf5f974",
    d: "M14.38,5.12l3.18,2.32a.51.51,0,0,1,.12.71h0a.49.49,0,0,1-.68.12h0L13.8,5.94Z"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "icon_edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e129e516-4322-4985-9ccd-15b0cd1faa41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a3b46dfc-64c3-4752-aa79-a11fc916e09d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ea0f3545-17bd-4439-8e78-3e7851311809",
    d: "M6.21,19.83V15.35a1,1,0,0,1,.19-.58l7.73-11a1,1,0,0,1,.65-.42,1,1,0,0,1,.74.17L18.8,5.77a1,1,0,0,1,.25,1.4l-7.71,11a1,1,0,0,1-.56.39ZM15,4.3,7.21,15.35v3.16l3.31-.91,7.71-11Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "afac3ede-3c30-4e87-8db5-fcb2fd5d64c4",
    className: "b28bf427-9fea-4ccf-8bda-1edddbf5f974",
    d: "M14.38,5.12l3.18,2.32a.51.51,0,0,1,.12.71h0a.49.49,0,0,1-.68.12h0L13.8,5.94Z"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "icon_date"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a153525d-2eaa-4797-93c1-d8bf91e93224",
    d: "M21.5,22H2.5A1.5,1.5,0,0,1,1,20.5V5.5A1.5,1.5,0,0,1,2.5,4h19A1.5,1.5,0,0,1,23,5.5v15A1.5,1.5,0,0,1,21.5,22ZM2.5,5a.5.5,0,0,0-.5.5v15a.5.5,0,0,0,.5.5h19a.5.5,0,0,0,.5-.5V5.5a.5.5,0,0,0-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b874abea-0f92-4528-a99b-7e1a2f5bd33e",
    className: "ae15a527-0328-4ce1-ab25-acb0baf44370",
    d: "M17.5,2h0a.5.5,0,0,1,.5.5v3a.5.5,0,0,1-.5.5h0a.5.5,0,0,1-.5-.5v-3A.5.5,0,0,1,17.5,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf0dc619-7c07-4355-b59c-42f41a5aeaca",
    className: "ae15a527-0328-4ce1-ab25-acb0baf44370",
    d: "M6.5,2h0a.5.5,0,0,1,.5.5v3a.5.5,0,0,1-.5.5h0A.5.5,0,0,1,6,5.5v-3A.5.5,0,0,1,6.5,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e452da72-bc4a-4b82-8c8b-02d682ee7a0d",
    className: "ae15a527-0328-4ce1-ab25-acb0baf44370",
    d: "M6.5,10h3a.5.5,0,0,1,.5.5h0a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5H6A.5.5,0,0,1,6.5,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa0f67e0-81ae-4fca-ab7e-6571ed4d8313",
    className: "ae15a527-0328-4ce1-ab25-acb0baf44370",
    d: "M6.5,13h3a.5.5,0,0,1,.5.5h0a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5H6A.5.5,0,0,1,6.5,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a6105a8a-7407-4951-9d33-483e2c2eb977",
    className: "ae15a527-0328-4ce1-ab25-acb0baf44370",
    d: "M6.5,16h3a.5.5,0,0,1,.5.5h0a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5H6A.5.5,0,0,1,6.5,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a0222b7b-48d1-4dec-a101-6e704a47bb5a",
    className: "ae15a527-0328-4ce1-ab25-acb0baf44370",
    d: "M14.5,10h3a.5.5,0,0,1,.5.5h0a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5h0A.5.5,0,0,1,14.5,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eebbcb37-a54d-44dc-8a09-5de959074425",
    className: "ae15a527-0328-4ce1-ab25-acb0baf44370",
    d: "M14.5,13h3a.5.5,0,0,1,.5.5h0a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5h0A.5.5,0,0,1,14.5,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bbb76915-21cf-48f1-aae0-54ecbc0f1ed4",
    className: "ae15a527-0328-4ce1-ab25-acb0baf44370",
    d: "M14.5,16h3a.5.5,0,0,1,.5.5h0a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5h0A.5.5,0,0,1,14.5,16Z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "icon_transfer"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4832529,21.008513 L13.2039311,19.0995739 C13.0501983,18.8701816 13.1115325,18.5595973 13.3409248,18.4058645 C13.5703171,18.2521316 13.8809014,18.3134658 14.0346342,18.5428581 L16.0043716,21.4820005 L13.9151975,24.1400456 C13.7445549,24.3571533 13.4302212,24.3948207 13.2131136,24.2241781 C12.996006,24.0535355 12.9583386,23.7392019 13.1289812,23.5220942 L14.3186279,22.008513 L9.44072201,22.008513 C9.16457964,22.008513 8.94072201,21.7846554 8.94072201,21.508513 C8.94072201,21.2323707 9.16457964,21.008513 9.44072201,21.008513 L14.4832529,21.008513 Z M1.90373495,22.1488835 C1.90373495,22.4250259 1.67987732,22.6488835 1.40373495,22.6488835 C1.12759257,22.6488835 0.903734945,22.4250259 0.903734945,22.1488835 C0.903734945,18.2100887 4.09675907,15.0170645 8.03555394,15.0170645 L15.9894319,15.0170645 C19.8722099,15.0170645 23.0198233,18.164678 23.0198233,22.0474559 C23.0198233,22.3235983 22.7959657,22.5474559 22.5198233,22.5474559 C22.243681,22.5474559 22.0198233,22.3235983 22.0198233,22.0474559 C22.0198233,18.7169627 19.3199251,16.0170645 15.9894319,16.0170645 L8.03555394,16.0170645 C4.64904382,16.0170645 1.90373495,18.7623734 1.90373495,22.1488835 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9507858,12.0429388 C8.63707733,12.0429388 5.95078583,9.35664727 5.95078583,6.04293877 C5.95078583,2.72923027 8.63707733,0.0429387689 11.9507858,0.0429387689 C15.2644943,0.0429387689 17.9507858,2.72923027 17.9507858,6.04293877 C17.9507858,9.35664727 15.2644943,12.0429388 11.9507858,12.0429388 Z M11.9507858,11.0429388 C14.7122096,11.0429388 16.9507858,8.80436252 16.9507858,6.04293877 C16.9507858,3.28151502 14.7122096,1.04293877 11.9507858,1.04293877 C9.18936208,1.04293877 6.95078583,3.28151502 6.95078583,6.04293877 C6.95078583,8.80436252 9.18936208,11.0429388 11.9507858,11.0429388 Z",
    id: "Oval-5"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "icon_c2c"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.625,17.0074878 L24.375,17.0074878 C24.7095044,17.0074878 25,16.703159 25,16.3051068 L25,1.70238095 C25,1.30432875 24.7095044,1 24.375,1 L1.625,1 C1.29049562,1 1,1.30432875 1,1.70238095 L1,16.3051068 C1,16.703159 1.29049562,17.0074878 1.625,17.0074878 Z M1.625,18.0074878 C0.727537282,18.0074878 0,17.2453059 0,16.3051068 L0,1.70238095 C0,0.762181914 0.727537282,0 1.625,0 L24.375,0 C25.2724627,0 26,0.762181914 26,1.70238095 L26,16.3051068 C26,17.2453059 25.2724627,18.0074878 24.375,18.0074878 L1.625,18.0074878 Z",
    id: "Rectangle-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    points: "0.0345350863 4.01982139 0.0345350863 3.01982139 25.8242227 3.01982139 25.8242227 4.01982139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.43462676,10.040514 C9.15848439,10.040514 8.93462676,9.81665635 8.93462676,9.54051397 C8.93462676,9.2643716 9.15848439,9.04051397 9.43462676,9.04051397 L15.9346268,9.04051397 C16.2107691,9.04051397 16.4346268,9.2643716 16.4346268,9.54051397 C16.4346268,9.81665635 16.2107691,10.040514 15.9346268,10.040514 L9.43462676,10.040514 Z",
    id: "Path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0433191,7.43585981 C13.8709021,7.22015867 13.9059908,6.90552673 14.121692,6.73310971 C14.3373931,6.56069269 14.652025,6.59578141 14.8244421,6.81148255 L16.9258175,9.44039403 L14.8276577,12.1218171 C14.6574862,12.3392942 14.343235,12.377643 14.1257579,12.2074716 C13.9082808,12.0373001 13.869932,11.7230489 14.0401035,11.5055718 L15.6508922,9.44700313 L14.0433191,7.43585981 Z",
    id: "Path-8"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "icon_other"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.07669373,26.9924055 L8.0118808,27.0469219 L6.44083607,28.1468055 C5.81380007,28.7722388 5.01806641,28.4492182 5.01806641,27.5616 L5.01806641,4.33845215 C5.01806641,3.62086225 5.60800411,3.03845215 6.32840634,3.03845215 L25.7261591,3.03845215 C26.4465613,3.03845215 27.036499,3.62086225 27.036499,4.33845215 L27.036499,27.5376 C27.036499,28.4217816 26.2419205,28.7493916 25.6822191,28.1907053 L23.9023069,26.9892689 C23.7805581,26.8706106 23.5744497,26.8713031 23.4535004,26.9910162 L22.0503438,28.376268 C21.5409282,28.8778905 20.7125777,28.8798793 20.201534,28.3805171 L18.7735555,26.9891696 C18.6532051,26.8712688 18.4508015,26.8723405 18.3310631,26.9920783 L16.9369506,28.3852055 C16.4295244,28.8913347 15.5999033,28.8961267 15.0889734,28.3955945 L13.6465347,26.9891696 C13.5256423,26.8707379 13.3198812,26.8713304 13.1987502,26.9909158 L11.7826319,28.3897639 C11.2734576,28.8937367 10.44383,28.8937367 9.93400496,28.3904169 L8.51443992,26.990565 C8.39515509,26.8724995 8.19623271,26.8731721 8.07669373,26.9924055 Z M9.21724499,26.2791831 L10.6363536,27.6785838 C10.7567696,27.7974633 10.9595152,27.7974633 11.0795205,27.6786842 L12.4960965,26.2793838 C13.0054189,25.7765604 13.8352724,25.7741707 14.3454903,26.2740055 L15.787929,27.6804304 C15.9079987,27.7980561 16.110752,27.796885 16.2304215,27.6775217 L17.6240821,26.2848457 C18.131336,25.7775944 18.9613022,25.7731999 19.4723853,26.2738829 L20.8999062,27.6647827 C21.0216698,27.7837628 21.227314,27.7832691 21.34825,27.6641838 L22.7504908,26.2798361 C23.2586813,25.776837 24.0881861,25.7740502 24.5294147,26.2156947 L26.036499,27.2330897 L26.036499,4.33845215 C26.036499,4.17604205 25.8971308,4.03845215 25.7261591,4.03845215 L6.32840634,4.03845215 C6.15743464,4.03845215 6.01806641,4.17604205 6.01806641,4.33845215 L6.01806641,27.2300021 L7.40470679,26.251471 C7.91534358,25.7774872 8.71869621,25.7857294 9.21724499,26.2791831 Z M12.0107422,10.0297852 L12.0107422,9.02978516 L23.0012207,9.02978516 L23.0012207,10.0297852 L12.0107422,10.0297852 Z M12.0091553,13.0028687 L12.0091553,12.0028687 L22.9860596,12.0028687 L22.9860596,13.0028687 L12.0091553,13.0028687 Z M12.0106201,16.0084229 L12.0106201,15.0084229 L23.0148315,15.0084229 L23.0148315,16.0084229 L12.0106201,16.0084229 Z M12.005249,19.0099487 L12.005249,18.0099487 L23.0084839,18.0099487 L23.0084839,19.0099487 L12.005249,19.0099487 Z M9.01300049,9.99389648 L9.01300049,8.99389648 L11.0147705,8.99389648 L11.0147705,9.99389648 L9.01300049,9.99389648 Z M9.00762939,12.9973145 L9.00762939,11.9973145 L11.0021362,11.9973145 L11.0021362,12.9973145 L9.00762939,12.9973145 Z M9.00299072,16.0192871 L9.00299072,15.0192871 L11.0148315,15.0192871 L11.0148315,16.0192871 L9.00299072,16.0192871 Z M9.0065918,19.0201416 L9.0065918,18.0201416 L11.0128784,18.0201416 L11.0128784,19.0201416 L9.0065918,19.0201416 Z",
    id: "Combined-Shape"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "icon_search"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7995436,15.0955524 C14.8199075,15.0537947 14.8464795,15.0141965 14.8793229,14.978096 C14.9248186,14.9280884 14.9781303,14.8894284 15.0357014,14.862284 C16.2518455,13.6030401 17,11.8888905 17,10 C17,6.13400675 13.8659932,3 10,3 C6.13400675,3 3,6.13400675 3,10 C3,13.8659932 6.13400675,17 10,17 C11.8577052,17 13.5463919,16.2763453 14.7995436,15.0955524 Z M15.9852663,15.3082955 L20.9562337,19.8307602 C21.1604929,20.0165903 21.1754327,20.33282 20.9896026,20.5370792 C20.8037726,20.7413384 20.4875428,20.7562782 20.2832837,20.5704482 L15.2753467,16.0143494 C13.867121,17.2505291 12.0210846,18 10,18 C5.581722,18 2,14.418278 2,10 C2,5.581722 5.581722,2 10,2 C14.418278,2 18,5.581722 18,10 C18,12.0368858 17.2387643,13.8959755 15.9852663,15.3082955 Z",
    id: "Combined-Shape"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "icon_menu-operations"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M43.976 20.5a6.04 6.04 0 0 1 6.036 5.815l.004.226V30h.037v8h-.037v1.459a6.04 6.04 0 0 1-5.813 6.037l-.227.004H22.69a6.04 6.04 0 0 1-6.035-5.815l-.004-.226V26.54a6.04 6.04 0 0 1 6.04-6.041.5.5 0 1 1 0 1 5.04 5.04 0 0 0-5.036 4.823l-.004.218V39.46a5.04 5.04 0 0 0 4.82 5.036l.22.005h21.285a5.04 5.04 0 0 0 5.035-4.823l.005-.218V38H41a4 4 0 1 1 0-8h8.016v-3.459a5.04 5.04 0 0 0-4.821-5.036l-.219-.005H37a.5.5 0 0 1-.09-.992L37 20.5h6.976zm5.04 10.5H41a3 3 0 0 0 0 6h8.016v-6zM41 33a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM29.99 15a.5.5 0 0 1 .5.5l-.001 7.123 2.203-1.722a.5.5 0 0 1 .682.727l-.066.061L30 24.275l-3.308-2.586a.5.5 0 0 1 .54-.837l.076.05 2.18 1.704.001-7.106a.5.5 0 0 1 .5-.5z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "icon_menu-clients"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M36.093 37.5a8.5 8.5 0 0 1 8.5 8.5.5.5 0 1 1-1 0 7.5 7.5 0 0 0-7.5-7.5H28a7.5 7.5 0 0 0-7.5 7.5.5.5 0 1 1-1 0 8.5 8.5 0 0 1 8.5-8.5zM32 18.5a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "icon_menu-messages"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M43 20.5a5.5 5.5 0 0 1 5.5 5.5v14a5.5 5.5 0 0 1-5.5 5.5H21a5.5 5.5 0 0 1-5.5-5.5V26a5.5 5.5 0 0 1 5.5-5.5h22zM24.871 31.208l-7.853 10.89A4.5 4.5 0 0 0 21 44.5h22a4.5 4.5 0 0 0 4.034-2.503l-7.425-10.209-3.934 3.806a4.5 4.5 0 0 1-6.08.162l-.173-.157-4.551-4.391zM41 40a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM17.115 23.727A4.48 4.48 0 0 0 16.5 26v14c0 .33.036.653.103.963l7.541-10.456-7.029-6.78zm30.103.703l-6.883 6.656 7.088 9.746c.05-.27.077-.548.077-.832V26c0-.552-.1-1.081-.282-1.57zM43 21.5H21c-1.294 0-2.46.546-3.28 1.42l7.138 6.886.675.486-.071.097 4.654 4.49a3.5 3.5 0 0 0 4.71.137l.154-.14 11.672-11.29.355.365A4.5 4.5 0 0 0 43 21.5z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "icon_menu-info"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e36cad99-382e-4fa0-abb1-ecea940dff89",
    d: "M41,48.5H24A5.51,5.51,0,0,1,18.5,43V21A5.51,5.51,0,0,1,24,15.5H41A5.51,5.51,0,0,1,46.5,21V43A5.51,5.51,0,0,1,41,48.5Zm-17-32A4.51,4.51,0,0,0,19.5,21V43A4.51,4.51,0,0,0,24,47.5H41A4.51,4.51,0,0,0,45.5,43V21A4.51,4.51,0,0,0,41,16.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fdaad494-cadc-44ab-9ec4-847da6f004c1",
    d: "M27.5,27h11a.5.5,0,0,1,.5.5h0a.5.5,0,0,1-.5.5h-11a.5.5,0,0,1-.5-.5h0A.5.5,0,0,1,27.5,27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fdaad494-cadc-44ab-9ec4-847da6f004c1",
    d: "M27.5,32h11a.5.5,0,0,1,.5.5h0a.5.5,0,0,1-.5.5h-11a.5.5,0,0,1-.5-.5h0A.5.5,0,0,1,27.5,32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fdaad494-cadc-44ab-9ec4-847da6f004c1",
    d: "M27.5,37h3a.5.5,0,0,1,.5.5h0a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5h0A.5.5,0,0,1,27.5,37Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "e36cad99-382e-4fa0-abb1-ecea940dff89",
    cx: 27.5,
    cy: 22.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "e36cad99-382e-4fa0-abb1-ecea940dff89",
    d: "M27.5,24A1.5,1.5,0,1,1,29,22.5,1.5,1.5,0,0,1,27.5,24Zm0-2a.5.5,0,1,0,.5.5A.5.5,0,0,0,27.5,22Z"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "icon_menu-counter"
  }, /*#__PURE__*/React.createElement("g", {
    id: "register_counterparty",
    transform: "translate(14.000000, 14.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.008,16 L0.008,15 L14.973,15 L14.973,16 L0.008,16 Z M16,14 L16,17 L20,17 L20,14 L16,14 Z M16,13 L20,13 C20.5522847,13 21,13.4477153 21,14 L21,17 C21,17.5522847 20.5522847,18 20,18 L16,18 C15.4477153,18 15,17.5522847 15,17 L15,14 C15,13.4477153 15.4477153,13 16,13 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.788,16.007 L20.788,15.007 L35.972,15.007 L35.972,16.007 L20.788,16.007 Z M14.022,5.533 L13.022,5.533 L13.022,2.46 C13.022,1.63157288 13.6935729,0.96 14.522,0.96 L21.522,0.96 C22.3504271,0.96 23.022,1.63157288 23.022,2.46 L23.022,5.533 L22.022,5.533 L22.022,2.46 C22.022,2.18385763 21.7981424,1.96 21.522,1.96 L14.522,1.96 C14.2458576,1.96 14.022,2.18385763 14.022,2.46 L14.022,5.533 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16,19 L48,19 C49.1045695,19 50,19.8954305 50,21 L50,36.5 C50,36.7761424 49.7761424,37 49.5,37 L49.5,37 C49.2238576,37 49,36.7761424 49,36.5 L49,21 C49,20.4477153 48.5522847,20 48,20 L16,20 C15.4477153,20 15,20.4477153 15,21 L15,43 C15,43.5522847 15.4477153,44 16,44 L39.5,44 C39.7761424,44 40,44.2238576 40,44.5 L40,44.5 C40,44.7761424 39.7761424,45 39.5,45 L16,45 C14.8954305,45 14,44.1045695 14,43 L14,21 C14,19.8954305 14.8954305,19 16,19 Z",
    id: "Rectangle-Copy-2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 47,
    y: 39,
    width: 1,
    height: 9,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 43,
    y: 43,
    width: 9,
    height: 1,
    rx: 0.5
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "icon_menu-income"
  }, /*#__PURE__*/React.createElement("g", {
    id: "64-x-64-outline-transfer-wallet",
    transform: "translate(12.000000, 15.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,21 C0.223857625,21 4.61852778e-14,20.8501424 4.61852778e-14,20.574 L4.61852778e-14,5.839 C4.61852778e-14,4.889 0.67490918,4 1.62590918,4 L31.2069092,1.77635684e-15 C32.1569092,1.77635684e-15 33.033,0.888 33.033,1.839 L33.033,5.503 C33.033,5.77914237 32.8091424,6.003 32.533,6.003 C32.2568576,6.003 32.033,5.77914237 32.033,5.503 L32.033,1.84 C32.0308139,1.43995029 31.6069589,1.00318611 31.2069092,1.001 L1.62690918,5.001 C1.22685947,5.00318611 1.00318611,5.43995029 1.001,5.84 L1,20.574 C0.850761583,20.858 0.684094917,21 0.5,21 Z M29.048,16.959 C29.048,16.4067153 28.6002847,15.959 28.048,15.959 C27.4957153,15.959 27.048,16.4067153 27.048,16.959 C27.048,17.5112847 27.4957153,17.959 28.048,17.959 C28.6002847,17.959 29.048,17.5112847 29.048,16.959 Z M28.0473336,18.959334 C26.9425799,18.959334 26.047,18.0637541 26.047,16.9590003 C26.047,15.8544306 26.9424306,14.959 28.0470003,14.959 C29.15157,14.959 30.0470006,15.8544306 30.0470006,16.9590003 C30.0476673,18.0637541 29.1520874,18.959334 28.0473336,18.959334 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13,20 L48,20 C49.1045695,20 50,20.8954305 50,22 L50,37.5 C50,37.7761424 49.7761424,38 49.5,38 L49.5,38 C49.2238576,38 49,37.7761424 49,37.5 L49,22 C49,21.4477153 48.5522847,21 48,21 L14,21 C13.4477153,21 13,21.4477153 13,22 L13,44 C13,44.5522847 13.4477153,45 14,45 L39.5,45 C39.7761424,45 40,45.2238576 40,45.5 L40,45.5 C40,45.7761424 39.7761424,46 39.5,46 L14,46 C12.8954305,46 12,45.1045695 12,44 L12,21 C12,20.4477153 12.4477153,20 13,20 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,29 L35,29 C34.4477153,29 34,29.4477153 34,30 L34,34 C34,34.5522847 34.4477153,35 35,35 L50,35 L50,36 L35,36 C33.8954305,36 33,35.1045695 33,34 L33,30 C33,28.8954305 33.8954305,28 35,28 L50,28 L50,29 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 47,
    y: 40,
    width: 1,
    height: 9,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 43,
    y: 44,
    width: 9,
    height: 1,
    rx: 0.5
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "icon_menu-settings"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ae2fc663-5404-40cc-ab3f-49f150c7cff5",
    className: "abc3811c-2faa-4433-acf2-dbebd4aa694e",
    d: "M32,39a7,7,0,1,1,7-7A7,7,0,0,1,32,39Zm0-1a6,6,0,1,0-6-6A6,6,0,0,0,32,38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a616949b-0d7a-4bb2-90f7-6066dfec99a7",
    d: "M32.05,50.5a4.1,4.1,0,0,1-4.11-4v-1.4a13.75,13.75,0,0,1-2.21-.92l-1,1a4.11,4.11,0,0,1-5.82-5.81l1-1A13.75,13.75,0,0,1,19,36.17H17.61a4.12,4.12,0,0,1,0-8.23H19a13.75,13.75,0,0,1,.92-2.21l-1-1a4.12,4.12,0,0,1,5.82-5.82l1,1A13.75,13.75,0,0,1,27.94,19V17.61a4.12,4.12,0,0,1,8.23,0V19a13.27,13.27,0,0,1,2.2.92l1-1a4.11,4.11,0,0,1,5.82,5.81l-1,1a13.75,13.75,0,0,1,.92,2.21H46.5a4.11,4.11,0,0,1,0,8.22h-1.4a13.75,13.75,0,0,1-.92,2.21l1,1a4.09,4.09,0,0,1,0,5.81,4.12,4.12,0,0,1-5.81,0l-1-1a13.38,13.38,0,0,1-2.21.92V46.5A4.09,4.09,0,0,1,32.05,50.5ZM25.56,43l.33.19a12.4,12.4,0,0,0,2.69,1.11l.36.1V46.5a3.11,3.11,0,0,0,6.22,0V44.36l.37-.11a12.11,12.11,0,0,0,2.69-1.11l.33-.19,1.52,1.52a3.18,3.18,0,0,0,4.4,0,3.11,3.11,0,0,0,0-4.4L43,38.55l.19-.32a12.48,12.48,0,0,0,1.11-2.7l.11-.36H46.5a3.11,3.11,0,0,0,0-6.22H44.36l-.11-.36a12.4,12.4,0,0,0-1.11-2.69L43,25.55,44.47,24a3.11,3.11,0,0,0-4.41-4.39l-1.51,1.51L38.22,21a12.4,12.4,0,0,0-2.69-1.11l-.36-.11V17.61a3.12,3.12,0,0,0-6.23,0v2.14l-.36.11A12.4,12.4,0,0,0,25.89,21l-.33.19L24,19.64a3.11,3.11,0,0,0-4.4,4.4l1.52,1.51-.19.34a12.4,12.4,0,0,0-1.11,2.69l-.11.36H17.61a3.12,3.12,0,0,0,0,6.23h2.14l.11.36A12.4,12.4,0,0,0,21,38.22l.19.33-1.52,1.52a3.11,3.11,0,0,0,4.4,4.4Z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "icon_menu-home"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f8cf1f1b-e0fa-43fc-b5be-90f698c2ee7f",
    d: "M45,48H21a5.41,5.41,0,0,1-5-5V33a4.66,4.66,0,0,1,1.64-3.35L30,17.28a4.53,4.53,0,0,1,6.3,0l12,12.37A4.63,4.63,0,0,1,50,33V43A5.41,5.41,0,0,1,45,48ZM18.36,30.35A3.71,3.71,0,0,0,17,33V43a4.4,4.4,0,0,0,4,4H45a4.4,4.4,0,0,0,4-4V33a3.76,3.76,0,0,0-1.35-2.65L35.62,18a3.52,3.52,0,0,0-4.89,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f8cf1f1b-e0fa-43fc-b5be-90f698c2ee7f",
    d: "M37,48H29V39a3.83,3.83,0,0,1,4-4,3.83,3.83,0,0,1,4,4Zm-7-1h6V39a3,3,0,0,0-6,0Z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "icon_menu-taxes"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "b90c0972-5f0e-4e20-b5b7-13460d1fc095",
    "data-name": "taxes"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ebe6368b-f7f8-42c9-abe9-258bc6c0e8c4",
    d: "M32.5,49.5a2.3,2.3,0,0,1-.45,0c-3.7-.93-6.17-2.79-7.35-5.54a1.79,1.79,0,0,1,.82-2.29,18.41,18.41,0,0,0,3.05-1.92,1.82,1.82,0,0,1-1.13-1.22c-.12-.44-.23-.85-.32-1.23a4.56,4.56,0,0,1-1.08.21,11.35,11.35,0,0,1-8.73-2.9A12.79,12.79,0,0,1,13.5,25c0-3.17.77-5,3.16-7.38A1.9,1.9,0,0,1,18,17.12a1.81,1.81,0,0,1,1.32.63l1.21,1.44A19.52,19.52,0,0,0,23,21.86a9.7,9.7,0,0,0,1,.71l.46.27-.14.5.26-.43.28.17a8,8,0,0,1,2.21,2.1,2.82,2.82,0,0,1,.23.6,2.5,2.5,0,0,0,.12-.86l0-.21c-.07-.4-.23-1.26-.28-1.41-.27-1-.59-1.47-2.33-1.27a1.86,1.86,0,0,1-1.42-.46,1.8,1.8,0,0,1-.6-1.34,3.29,3.29,0,0,1,2-3,2.42,2.42,0,0,1,2.46-2.73A2.48,2.48,0,0,1,29.7,17a3.13,3.13,0,0,1,0,.44,7.62,7.62,0,0,1,2.84,2.17,7.55,7.55,0,0,1,2.84-2.17,2.71,2.71,0,0,1,0-.41,2.49,2.49,0,1,1,5,0c0,.08,0,.16,0,.25a3.29,3.29,0,0,1,2,3,1.8,1.8,0,0,1-.6,1.34,1.86,1.86,0,0,1-1.42.46c-1.75-.2-2.06.26-2.33,1.27,0,.14-.19.95-.27,1.36l-.05.26a2.5,2.5,0,0,0,.12.86,3,3,0,0,1,.23-.6,8.9,8.9,0,0,1,2.42-2.1l.35-.2.52-.31c.35-.22.66-.44,1-.71a13.1,13.1,0,0,0,1.87-2.17c.46-.59,1-1.27,1.55-1.94A1.81,1.81,0,0,1,47,17.12a1.85,1.85,0,0,1,1.36.54c2.4,2.42,3.17,4.21,3.17,7.38a12.79,12.79,0,0,1-3.81,9.52A11.31,11.31,0,0,1,39,37.46a4.66,4.66,0,0,1-1.08-.21c-.09.38-.2.79-.32,1.23a1.82,1.82,0,0,1-1.13,1.22,18.41,18.41,0,0,0,3,1.92,1.78,1.78,0,0,1,.81,2.3c-1.17,2.74-3.64,4.6-7.34,5.53A2.3,2.3,0,0,1,32.5,49.5ZM27.85,35.91l.12.57c.11.51.26,1.09.44,1.74a.79.79,0,0,0,.56.56,4.56,4.56,0,0,1,.73.27l.54.27-.36.48A13.29,13.29,0,0,1,26,42.5a.81.81,0,0,0-.37,1c1.05,2.44,3.29,4.11,6.68,4.95a.68.68,0,0,0,.4,0c3.39-.84,5.63-2.51,6.68-4.95a.81.81,0,0,0-.37-1,13.29,13.29,0,0,1-3.89-2.7l-.36-.48.54-.27a4.71,4.71,0,0,1,.74-.27.79.79,0,0,0,.55-.57c.18-.64.33-1.22.44-1.73l.12-.57.76.29a4.14,4.14,0,0,0,1.12.26,10.31,10.31,0,0,0,8-2.63A11.83,11.83,0,0,0,50.5,25c0-2.93-.65-4.43-2.88-6.68a.78.78,0,0,0-.61-.24.8.8,0,0,0-.6.28c-.55.65-1,1.28-1.51,1.9a13.73,13.73,0,0,1-2.06,2.35,10.34,10.34,0,0,1-1.1.77l-.44.26-.42.25a8.25,8.25,0,0,0-2.06,1.7c-.19.39-.21.59-.15,1.55v.25a2.26,2.26,0,0,1,0,.25v.63l-.61-.13-.3-.08-.17-.05-.1-.15a6,6,0,0,1-.92-3.18l0-.24c.08-.44.24-1.29.28-1.44.45-1.67,1.41-2.23,3.41-2a.8.8,0,0,0,.64-.2.82.82,0,0,0,.27-.6A2.43,2.43,0,0,0,39.52,18l-.44-.16.13-.45a1.4,1.4,0,0,0,.06-.41,1.49,1.49,0,1,0-3,0,1.61,1.61,0,0,0,.1.53l.18.47-.47.18a6.41,6.41,0,0,0-3.19,2.52l-.42.63-.42-.63a6.51,6.51,0,0,0-3.2-2.53L28.4,18l.19-.48A1.41,1.41,0,0,0,28.7,17a1.49,1.49,0,0,0-3,0,1.25,1.25,0,0,0,.07.43l.14.45-.45.16a2.45,2.45,0,0,0-1.74,2.23.81.81,0,0,0,.91.8c2-.22,2.95.34,3.41,2,0,.15.21,1.06.29,1.49l0,.19a6,6,0,0,1-.92,3.18l-.1.15-.17.05-.3.08-.61.13v-.63a2.36,2.36,0,0,1,0-.25v-.25c.06-1,0-1.16-.15-1.55a7.43,7.43,0,0,0-1.84-1.7L24,23.74l-.54-.32a12.88,12.88,0,0,1-1.1-.77,20.47,20.47,0,0,1-2.59-2.82c-.38-.46-.77-.95-1.19-1.43a.8.8,0,0,0-.6-.28.76.76,0,0,0-.61.24C15.15,20.61,14.5,22.11,14.5,25A11.83,11.83,0,0,0,18,33.83a10.28,10.28,0,0,0,8,2.63,4.29,4.29,0,0,0,1.33-.33Z"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "f996321a-ae9c-4a69-98d1-8fa5e2a3c124",
    "data-name": "Oval",
    className: "ebe6368b-f7f8-42c9-abe9-258bc6c0e8c4",
    cx: 39.5,
    cy: 39.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e78db6a0-a05f-4a71-a4e3-2309a4760847",
    "data-name": "Oval-Copy",
    className: "ebe6368b-f7f8-42c9-abe9-258bc6c0e8c4",
    cx: 25.5,
    cy: 39.5,
    r: 1.5
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "icon_waiting"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.79746,20.1464684 L42.4641572,20.1464684 C42.7402996,20.1464684 42.9641572,19.9226107 42.9641572,19.6464684 L42.9641572,17.7409773 C42.9641572,17.31466 43.1455604,16.9084818 43.4630322,16.6239505 C44.0799491,16.0710445 45.0282779,16.1229354 45.581184,16.7398523 L52.7248368,24.7105363 C53.257527,25.3048969 53.2315024,26.2123074 52.6656232,26.7751609 L45.5794972,33.8233984 C45.2984273,34.1029655 44.9181156,34.2598989 44.521684,34.2598989 C43.6932569,34.2598989 43.021684,33.588326 43.021684,32.7598989 L43.021684,30.5824782 C43.021684,30.3063359 42.7978264,30.0824782 42.521684,30.0824782 L25.79746,30.0824782 C24.9690329,30.0824782 24.29746,29.4109054 24.29746,28.5824782 L24.29746,21.6464684 C24.29746,20.8180412 24.9690329,20.1464684 25.79746,20.1464684 Z M25.29746,28.5824782 C25.29746,28.8586206 25.5213176,29.0824782 25.79746,29.0824782 L42.521684,29.0824782 C43.3501111,29.0824782 44.021684,29.7540511 44.021684,30.5824782 L44.021684,32.7598989 C44.021684,33.0360412 44.2455416,33.2598989 44.521684,33.2598989 C44.6538279,33.2598989 44.7805984,33.2075877 44.8742884,33.1143987 L51.9604144,26.0661612 C52.1490408,25.8785433 52.1577157,25.5760732 51.9801523,25.377953 L44.8364995,17.4072689 C44.6521975,17.20163 44.3360879,17.184333 44.1304489,17.368635 C44.024625,17.4634788 43.9641572,17.5988715 43.9641572,17.7409773 L43.9641572,19.6464684 C43.9641572,20.4748955 43.2925844,21.1464684 42.4641572,21.1464684 L25.79746,21.1464684 C25.5213176,21.1464684 25.29746,21.370326 25.29746,21.6464684 L25.29746,28.5824782 Z",
    id: "Path-36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3699318,35.0575357 L28.2576888,35.0575357 C28.5338311,35.0575357 28.7576888,34.833678 28.7576888,34.5575357 L28.7576888,32.4594508 C28.7576888,32.05419 28.9216696,31.6661734 29.2122995,31.3837365 C29.8064,30.8063839 30.7560505,30.8199609 31.333403,31.4140615 L38.700669,38.9950392 C39.2632655,39.5739557 39.2668032,40.4942926 38.7086738,41.0775171 L31.3989347,48.7159234 C31.1159726,49.0116083 30.7244796,49.1788348 30.3152155,49.1788348 C29.4867884,49.1788348 28.8152155,48.5072619 28.8152155,47.6788348 L28.8152155,45.5876427 C28.8152155,45.3115004 28.5913579,45.0876427 28.3152155,45.0876427 L12.3699318,45.0876427 C11.5415047,45.0876427 10.8699318,44.4160699 10.8699318,43.5876427 L10.8699318,36.5575357 C10.8699318,35.7291085 11.5415047,35.0575357 12.3699318,35.0575357 Z M11.8699318,43.5876427 C11.8699318,43.8637851 12.0937894,44.0876427 12.3699318,44.0876427 L28.3152155,44.0876427 C29.1436427,44.0876427 29.8152155,44.7592156 29.8152155,45.5876427 L29.8152155,47.6788348 C29.8152155,47.9549772 30.0390732,48.1788348 30.3152155,48.1788348 C30.4516369,48.1788348 30.5821346,48.1230926 30.6764552,48.024531 L37.9861944,40.3861247 C38.1722375,40.1917165 38.1710583,39.8849375 37.9835261,39.6919654 L30.6162602,32.1109877 C30.4238093,31.9129541 30.1072592,31.9084285 29.9092257,32.1008793 C29.812349,32.195025 29.7576888,32.3243638 29.7576888,32.4594508 L29.7576888,34.5575357 C29.7576888,35.3859628 29.0861159,36.0575357 28.2576888,36.0575357 L12.3699318,36.0575357 C12.0937894,36.0575357 11.8699318,36.2813933 11.8699318,36.5575357 L11.8699318,43.5876427 Z",
    id: "Path-36",
    transform: "translate(24.997443, 40.069142) scale(-1, 1) translate(-24.997443, -40.069142) "
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "icon_history"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M8.132 5.95a.502.502 0 1 1 0 1.001c-2.726 0-4.95 2.144-5.065 4.832l-.005.22v10.944c0 2.716 2.152 4.932 4.85 5.046l.22.005h15.813c2.726 0 4.95-2.144 5.065-4.832l.003-.167-5.035.001C21.781 23 20 21.21 20 19s1.781-4 3.978-4h5.036v-2.937c0-2.716-2.152-4.931-4.85-5.046l-.22-.005h-4.443a.502.502 0 0 1-.09-.994l.09-.008h4.444c3.279 0 5.952 2.589 6.071 5.826l.005.227v10.884c0 3.267-2.598 5.93-5.849 6.049l-.227.004H8.132c-3.28 0-5.952-2.588-6.072-5.826l-.004-.227V12.002c0-3.343 2.72-6.053 6.076-6.053zM29.014 16h-5.01A3.002 3.002 0 0 0 21 19c0 1.657 1.345 3 3.003 3h5.01v-6zm-4.99 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM13.5 0a.5.5 0 0 1 .5.5v6.961l2.223-1.387a.5.5 0 0 1 .635.087l.054.072a.5.5 0 0 1-.16.689L13.5 8.953l-3.244-2.031a.5.5 0 0 1 .53-.848L13 7.46V.5a.5.5 0 0 1 .5-.5z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "icon_history_r"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.024,
    cy: 19,
    r: 1,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.547 2.54l-5.015 4.983M11.532 2.54l5.015 4.983"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M19.49 6.004h4.455c3.279 0 5.952 2.588 6.071 5.826l.005.227v10.89c0 3.267-2.598 5.93-5.849 6.049l-.227.004H8.132c-3.28 0-5.952-2.588-6.072-5.826l-.004-.227v-10.89c0-3.343 3.098-6.053 6.453-6.053a.502.502 0 1 1 0 1.002c-2.73 0-5.315 2.15-5.442 4.842l-.005.209v10.89c0 2.716 2.152 4.932 4.85 5.046l.22.005h15.813c2.726 0 4.95-2.144 5.065-4.832l.003-.171V23h-5.035C21.781 23 20 21.21 20 19s1.781-4 3.978-4h5.036v-2.943c0-2.717-2.152-4.932-4.85-5.047l-.22-.004H19.49a.502.502 0 0 1-.09-.994l.09-.008h4.455zM29.014 16h-5.01A3.002 3.002 0 0 0 21 19c0 1.657 1.345 3 3.003 3h5.01v-6zm-4.99 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "icon_history_clients"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 11,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    d: "M8.1 24h15.893a5.002 5.002 0 0 0-4.9-4H13a5.002 5.002 0 0 0-4.9 4z"
  })))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "icon_security"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a51c0b46-8b50-4b73-9ed8-536337edbdc3",
    d: "M46.36,24.88H46.3a.5.5,0,0,1-.44-.55q.06-.63.12-1.23a46.42,46.42,0,0,0,0-7.16,8.5,8.5,0,0,1-6.65,2.85c-3.24,0-6.1-1.51-7.24-3.78H32c-1.14,2.27-4,3.78-7.24,3.78a8.49,8.49,0,0,1-6.65-2.85,46.2,46.2,0,0,0,0,7.22c0,.38.07.77.11,1.17a.5.5,0,0,1-.44.55.49.49,0,0,1-.55-.45c-.05-.4-.09-.8-.12-1.19a42.5,42.5,0,0,1,.13-8.8.51.51,0,0,1,.5-.43.62.62,0,0,1,.54.31c.88,2.07,3.48,3.47,6.46,3.47s5.58-1.4,6.46-3.47a.5.5,0,0,1,.46-.31h.73a.5.5,0,0,1,.46.31c.88,2.07,3.47,3.47,6.46,3.47s5.58-1.4,6.46-3.47a.5.5,0,0,1,.46-.31.58.58,0,0,1,.57.43A41.45,41.45,0,0,1,47,23.18c0,.41-.07.83-.12,1.25A.49.49,0,0,1,46.36,24.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a51c0b46-8b50-4b73-9ed8-536337edbdc3",
    d: "M32.05,50a.56.56,0,0,1-.27-.08c-7.2-4.62-11.85-11.69-13.82-21a.5.5,0,0,1,1-.21c1.88,8.93,6.29,15.72,13.11,20.19,6.87-4.51,11.3-11.36,13.16-20.39a.5.5,0,0,1,.59-.39.51.51,0,0,1,.39.59c-1.94,9.42-6.61,16.55-13.87,21.21A.5.5,0,0,1,32.05,50Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a51c0b46-8b50-4b73-9ed8-536337edbdc3",
    d: "M36.12,34.64a.49.49,0,0,1-.35-.15l-8.14-8.13a.5.5,0,0,1,.71-.71l8.14,8.14a.5.5,0,0,1,0,.7A.51.51,0,0,1,36.12,34.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a51c0b46-8b50-4b73-9ed8-536337edbdc3",
    d: "M28,34.64a.51.51,0,0,1-.36-.15.5.5,0,0,1,0-.7l8.14-8.14a.5.5,0,0,1,.71.71l-8.14,8.13A.49.49,0,0,1,28,34.64Z"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "icon_income-cancel"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.147 5.08c2.1 0 3.813 1.667 3.918 3.76l.005.204V18c0 2.12-1.647 3.852-3.721 3.958l-.202.005H4.942c-2.1 0-3.813-1.666-3.918-3.76L1.019 18V9.044c0-2.188 1.755-3.964 3.923-3.964a.5.5 0 1 1 0 1c-1.556 0-2.83 1.233-2.918 2.79l-.005.174V18c0 1.58 1.218 2.868 2.751 2.958l.172.005h14.205c1.555 0 2.829-1.232 2.918-2.789L22.07 18l-.001-2h-6.016a3 3 0 0 1 0-6h6.016v-.956c0-1.58-1.217-2.869-2.75-2.959l-.172-.005h-6.881a.5.5 0 0 1-.09-.992l.09-.008h6.88zM22 11h-5.947a2 2 0 1 0 0 4H22v-4zm-6 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-5.684-8.356a.5.5 0 0 1 .004.707L9.184 5.5l1.136 1.149a.5.5 0 0 1 .054.638l-.058.069a.5.5 0 0 1-.638.054l-.07-.059-1.126-1.14-1.126 1.14a.5.5 0 1 1-.712-.702L7.78 5.5 6.644 4.351a.5.5 0 0 1-.054-.638l.059-.069a.5.5 0 0 1 .638-.054l.069.059 1.126 1.139 1.127-1.14a.5.5 0 0 1 .707-.004z"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "icon_trash"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9673237,13.193147 L13.5886567,11.6390423 C13.7880081,11.4479569 14.1045197,11.4546579 14.2956051,11.6540093 C14.4866904,11.8533608 14.4799895,12.1698723 14.280638,12.3609577 L12.6898865,13.8857489 L14.280638,15.4105402 C14.4799895,15.6016255 14.4866904,15.9181371 14.2956051,16.1174885 C14.1045197,16.31684 13.7880081,16.3235409 13.5886567,16.1324556 L11.9673237,14.5783509 L10.3459907,16.1324556 C10.1466392,16.3235409 9.83012766,16.31684 9.63904229,16.1174885 C9.44795693,15.9181371 9.45465791,15.6016255 9.65400934,15.4105402 L11.2447608,13.8857489 L9.65400934,12.3609577 C9.45465791,12.1698723 9.44795693,11.8533608 9.63904229,11.6540093 C9.83012766,11.4546579 10.1466392,11.4479569 10.3459907,11.6390423 L11.9673237,13.193147 Z M6.15300969,8 L7.8672954,20 L16.1327046,20 L17.8469903,8 L6.15300969,8 Z M5,7 L19,7 L17,21 L7,21 L5,7 Z M4.5,5 L19.5,5 C19.7761424,5 20,5.22385763 20,5.5 C20,5.77614237 19.7761424,6 19.5,6 L4.5,6 C4.22385763,6 4,5.77614237 4,5.5 C4,5.22385763 4.22385763,5 4.5,5 Z M11.5,3 L12.5,3 C12.7761424,3 13,3.22385763 13,3.5 C13,3.77614237 12.7761424,4 12.5,4 L11.5,4 C11.2238576,4 11,3.77614237 11,3.5 C11,3.22385763 11.2238576,3 11.5,3 Z",
    id: "Combined-Shape"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "icon_notifications"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2820704,48.0274959 L24.2808903,50.0951505 C24.8021285,50.6349551 25.6436027,50.6347399 26.1641241,50.0942888 L28.1579923,48.0282191 C28.5241974,47.64897 29.1390279,47.6466621 29.5056362,48.0234103 L31.5372863,50.1014125 C32.0587983,50.637348 32.9002719,50.6323434 33.4189479,50.0896407 L35.3816136,48.0322498 C35.7454765,47.650558 36.3573544,47.6465964 36.7239039,48.0232848 L38.734871,50.0786859 C39.2575098,50.6144046 40.0993254,50.612347 40.6202509,50.0742538 L42.5953253,48.0288295 C42.9611656,47.6489836 43.5761279,47.6465804 43.9174421,47.9975614 L45.967549,49.802182 C46.4459274,50.3030931 47.0126623,50.0317663 47.0126623,49.182934 L47.0126623,13.4242004 C47.0126623,13.1402319 46.7938846,12.9218654 46.5155726,12.9218654 L18.5417289,12.9218654 C18.2681658,12.9218654 18.0446392,13.1467105 18.0446392,13.4251669 L18.0446392,49.2183797 C18.0446392,50.0839577 18.6191244,50.3306697 19.1988489,49.72455 L20.8842139,48.0833301 L20.9624595,48.0142897 C21.3284607,47.6511359 21.9229782,47.6546559 22.2820704,48.0274959 Z M19.909237,50.4281344 C18.7080544,51.6849602 17.0446392,50.9706085 17.0446392,49.2183797 L17.0446392,13.4251669 C17.0446392,12.5957379 17.7145604,11.9218654 18.5417289,11.9218654 L46.5155726,11.9218654 C47.3457486,11.9218654 48.0126623,12.5875255 48.0126623,13.4242004 L48.0126623,49.182934 C48.0126623,50.894076 46.3759083,51.6776789 45.2758498,50.5230482 L43.2761235,48.7634017 L41.3391735,50.7693436 C40.4260381,51.7125735 38.9353652,51.7162171 38.0195801,50.7775124 L36.0576976,48.7722786 L34.1421961,50.7802288 C33.232244,51.7323332 31.7376509,51.7412222 30.8214256,50.7996546 L28.8344336,48.7673294 L26.8840394,50.7883505 C25.9707569,51.7366014 24.4761476,51.7369837 23.5617188,50.789983 L21.6127288,48.7738733 L19.909237,50.4281344 Z M21.6634321,48.7273345 L21.6677403,48.7231944 C21.6663526,48.7246464 21.6649149,48.7260265 21.6634321,48.7273345 Z M28.5,22 L37.5,22 C37.7761424,22 38,22.2238576 38,22.5 C38,22.7761424 37.7761424,23 37.5,23 L28.5,23 C28.2238576,23 28,22.7761424 28,22.5 C28,22.2238576 28.2238576,22 28.5,22 Z M25.5,22 C25.7761424,22 26,22.2238576 26,22.5 C26,22.7761424 25.7761424,23 25.5,23 C25.2238576,23 25,22.7761424 25,22.5 C25,22.2238576 25.2238576,22 25.5,22 Z M28.5,26 L37.5,26 C37.7761424,26 38,26.2238576 38,26.5 C38,26.7761424 37.7761424,27 37.5,27 L28.5,27 C28.2238576,27 28,26.7761424 28,26.5 C28,26.2238576 28.2238576,26 28.5,26 Z M25.5,26 C25.7761424,26 26,26.2238576 26,26.5 C26,26.7761424 25.7761424,27 25.5,27 C25.2238576,27 25,26.7761424 25,26.5 C25,26.2238576 25.2238576,26 25.5,26 Z M28.5,30 L37.5,30 C37.7761424,30 38,30.2238576 38,30.5 C38,30.7761424 37.7761424,31 37.5,31 L28.5,31 C28.2238576,31 28,30.7761424 28,30.5 C28,30.2238576 28.2238576,30 28.5,30 Z M25.5,30 C25.7761424,30 26,30.2238576 26,30.5 C26,30.7761424 25.7761424,31 25.5,31 C25.2238576,31 25,30.7761424 25,30.5 C25,30.2238576 25.2238576,30 25.5,30 Z M28.5,34 L37.5,34 C37.7761424,34 38,34.2238576 38,34.5 C38,34.7761424 37.7761424,35 37.5,35 L28.5,35 C28.2238576,35 28,34.7761424 28,34.5 C28,34.2238576 28.2238576,34 28.5,34 Z M25.5,34 C25.7761424,34 26,34.2238576 26,34.5 C26,34.7761424 25.7761424,35 25.5,35 C25.2238576,35 25,34.7761424 25,34.5 C25,34.2238576 25.2238576,34 25.5,34 Z",
    id: "Combined-Shape"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "icon_landing01"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(10 12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 96,
    fill: "#E8F0FA",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 8,
    x: 26,
    y: 48,
    fill: "#FFF",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5458",
    d: "M52 28a7 7 0 0 1 6.996 6.76L59 35H42a7 7 0 0 1 7-7h3zm-1.5-9a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 8,
    x: 26,
    y: 61,
    fill: "#FFF",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M34 63a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm16 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm-8 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm16 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm8 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "icon_landing02"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(10 12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 96,
    fill: "#E8F0FA",
    rx: 5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 30)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 35,
    x: 21,
    fill: "#FFF",
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F6FF",
    d: "M90 0h10v35H90a5 5 0 0 1-5-5V5a5 5 0 0 1 5-5zM10 0H0v35h10a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5458",
    d: "M42.793 14.347c-.177.08-.325.316-.33.525l-.016.693c-.005.21-.164.408-.352.44l-1.485.264c-.189.033-.372-.108-.408-.313l-.12-.701a1.478 1.478 0 0 1 .085-.717l1.101-2.506c.083-.189.307-.345.498-.348l2.196-.034c.191-.003.35-.176.355-.386l.002-.098c.004-.21-.083-.52-.194-.69l-.299-.46a1.43 1.43 0 0 0-.523-.452l-.959-.422a1.976 1.976 0 0 0-.67-.142h-1.16c-.192 0-.421.15-.512.335l-1.837 3.734c-.09.185-.239.185-.33 0L36 9.335C35.91 9.15 35.68 9 35.488 9h-1.161c-.19 0-.493.063-.67.142l-.959.422a1.44 1.44 0 0 0-.523.452l-.298.46c-.111.17-.198.48-.195.69l.002.098c.003.21.163.383.354.386l2.197.034c.19.003.415.16.497.348l1.102 2.506c.083.19.12.511.086.717l-.121.7c-.036.206-.22.347-.409.314l-1.484-.263c-.189-.033-.347-.232-.352-.441l-.016-.693c-.005-.209-.154-.445-.33-.525l-4.887-2.191c-.177-.08-.321.027-.321.237l.016 6.724c0 .21.115.497.256.638l3.98 3.988a.97.97 0 0 0 .603.253l3.033-.033a.746.746 0 0 1 .553.301l.39.577a.534.534 0 0 1-.022.593l-1.465 1.842c-.126.158-.088.361.084.453l2.26 1.203a.748.748 0 0 0 .625 0l2.259-1.203c.172-.092.21-.295.085-.453l-1.465-1.842a.536.536 0 0 1-.022-.593l.39-.577a.746.746 0 0 1 .553-.301l3.031.033a.968.968 0 0 0 .604-.253l3.98-3.988c.142-.141.258-.428.258-.638L48 12.393c0-.21-.144-.316-.321-.237l-4.886 2.191z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M60 18a1 1 0 0 1 0 2h-3a1 1 0 0 1 0-2h3zm8-5a1 1 0 0 1 0 2H57a1 1 0 0 1 0-2h11z"
  }))))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "icon_landing03"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(7 19)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 70,
    fill: "#E8F0FA",
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 9,
    x: 13,
    y: 13,
    fill: "#FFF",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M25 44a1 1 0 0 1 0 2H14a1 1 0 0 1 0-2h11zm20 0a1 1 0 0 1 0 2H33a1 1 0 0 1 0-2h12zm21 0a1 1 0 0 1 0 2H54a1 1 0 0 1 0-2h12zm20 0a1 1 0 0 1 0 2H74a1 1 0 0 1 0-2h12z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76 48)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#FF5458"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M12.245 16.287c.893 0 1.603.238 2.131.713.528.475.792 1.126.792 1.952 0 .978-.317 1.73-.953 2.258-.636.527-1.545.79-2.727.79-1.027 0-1.857-.158-2.488-.473v-1.599c.333.168.72.305 1.162.41.442.106.86.159 1.256.159 1.191 0 1.787-.463 1.787-1.39 0-.881-.617-1.323-1.85-1.323-.223 0-.47.021-.739.063a5.66 5.66 0 0 0-.656.135l-.777-.395.347-4.461h5.007v1.569h-3.296l-.17 1.718.22-.042c.258-.056.575-.084.954-.084zm5.493-.538c0 .506.047.885.142 1.134.095.25.247.374.458.374.404 0 .606-.503.606-1.508 0-.999-.202-1.498-.606-1.498-.21 0-.363.123-.458.369-.095.245-.142.622-.142 1.129zm2.797-.012c0 .918-.187 1.607-.562 2.068-.375.461-.924.692-1.648.692-.694 0-1.231-.237-1.61-.71s-.568-1.156-.568-2.05c0-1.825.726-2.737 2.178-2.737.711 0 1.258.237 1.639.71.38.473.57 1.148.57 2.027zm4.344-2.611l-5.12 8.754h-1.516l5.12-8.754h1.516zm-.676 6.12c0 .506.047.885.142 1.134.095.25.247.374.458.374.404 0 .606-.502.606-1.508 0-.998-.202-1.497-.606-1.497-.21 0-.363.122-.458.368-.095.245-.142.622-.142 1.129zM27 19.234c0 .914-.187 1.601-.562 2.062-.375.461-.924.692-1.648.692-.694 0-1.23-.237-1.61-.71-.379-.473-.568-1.154-.568-2.044 0-1.825.726-2.737 2.178-2.737.712 0 1.258.237 1.639.71.38.473.571 1.148.571 2.027z"
  }))))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "icon_landing04"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 96,
    fill: "#E8F0FA",
    rx: 5,
    transform: "translate(7 12)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 25,
    x: 18,
    y: 32,
    fill: "#FFF",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 25,
    x: 62,
    y: 32,
    fill: "#FFF",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 32,
    x: 18,
    y: 61,
    fill: "#F0F6FF",
    rx: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 21,
    r: 2,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 21,
    r: 2,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 21,
    r: 2,
    fill: "#FF5458"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    x: 24,
    y: 68,
    fill: "#FF5458",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 2,
    x: 45,
    y: 70,
    fill: "#333",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 2,
    x: 45,
    y: 77,
    fill: "#333",
    rx: 1
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "icon_landing03_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,13 L95,13 C98.3137085,13 101,15.6862915 101,19 L101,104.090624 C101,105.195193 100.104569,106.090624 99,106.090624 C98.7551062,106.090624 98.5122948,106.045647 98.2836487,105.957932 L90.875,103.115769 L90.875,103.115769 L81.4663513,106.725188 C81.0051696,106.90211 80.4948304,106.90211 80.0336487,106.725188 L70.625,103.115769 L70.625,103.115769 L61.2163513,106.725188 C60.7551696,106.90211 60.2448304,106.90211 59.7836487,106.725188 L50.375,103.115769 L50.375,103.115769 L40.9663513,106.725188 C40.5051696,106.90211 39.9948304,106.90211 39.5336487,106.725188 L30.125,103.115769 L30.125,103.115769 L22.7163513,105.957932 C21.6850654,106.353562 20.5283215,105.838261 20.1326916,104.806975 C20.0449766,104.578329 20,104.335518 20,104.090624 L20,19 C20,15.6862915 22.6862915,13 26,13 Z",
    id: "Rectangle",
    fill: "#E8F0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,58 C56.5522847,58 57,58.4477153 57,59 C57,59.5522847 56.5522847,60 56,60 L42,60 C41.4477153,60 41,59.5522847 41,59 C41,58.4477153 41.4477153,58 42,58 L56,58 Z M79,51 C79.5522847,51 80,51.4477153 80,52 C80,52.5522847 79.5522847,53 79,53 L42,53 C41.4477153,53 41,52.5522847 41,52 C41,51.4477153 41.4477153,51 42,51 L79,51 Z M79,44 C79.5522847,44 80,44.4477153 80,45 C80,45.5522847 79.5522847,46 79,46 L42,46 C41.4477153,46 41,45.5522847 41,45 C41,44.4477153 41.4477153,44 42,44 L79,44 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F0F6FF",
    x: 41,
    y: 27,
    width: 17,
    height: 9,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 41,
    y: 68,
    width: 39,
    height: 18,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7142842,78.2232158 C63.1802745,78.2232158 63.5580342,78.6009755 63.5580342,79.0669658 L63.5580342,80.7544658 C63.5580342,81.220456 63.1802745,81.5982158 62.7142842,81.5982158 C62.248294,81.5982158 61.8705342,81.220456 61.8705342,80.7544658 L61.8705342,79.0669658 C61.8705342,78.6009755 62.248294,78.2232158 62.7142842,78.2232158 Z M60.5,72.371351 C60.9659903,72.371351 61.34375,72.7491108 61.34375,73.215101 L61.34375,80.5990326 C61.34375,81.0650228 60.9659903,81.4427826 60.5,81.4427826 C60.0340097,81.4427826 59.65625,81.0650228 59.65625,80.5990326 L59.65625,73.215101 C59.65625,72.7491108 60.0340097,72.371351 60.5,72.371351 Z M68.09375,72.371351 C68.5597403,72.371351 68.9375,72.7491108 68.9375,73.215101 L68.9375,80.5990326 C68.9375,81.0650228 68.5597403,81.4427826 68.09375,81.4427826 C67.6277597,81.4427826 67.25,81.0650228 67.25,80.5990326 L67.25,73.215101 C67.25,72.7491108 67.6277597,72.371351 68.09375,72.371351 Z M70.625,72.371351 C71.0909903,72.371351 71.46875,72.7491108 71.46875,73.215101 L71.46875,80.5990326 C71.46875,81.0650228 71.0909903,81.4427826 70.625,81.4427826 C70.1590097,81.4427826 69.78125,81.0650228 69.78125,80.5990326 L69.78125,73.215101 C69.78125,72.7491108 70.1590097,72.371351 70.625,72.371351 Z M73.15625,72.371351 C73.6222403,72.371351 74,72.7491108 74,73.215101 L74,80.5990326 C74,81.0650228 73.6222403,81.4427826 73.15625,81.4427826 C72.6902597,81.4427826 72.3125,81.0650228 72.3125,80.5990326 L72.3125,73.215101 C72.3125,72.7491108 72.6902597,72.371351 73.15625,72.371351 Z M57.6517842,72.3169658 C58.1177745,72.3169658 58.4955342,72.6947255 58.4955342,73.1607158 L58.4955342,80.5446473 C58.4955342,81.0106375 58.1177745,81.3883973 57.6517842,81.3883973 C57.185794,81.3883973 56.8080342,81.0106375 56.8080342,80.5446473 L56.8080342,73.1607158 C56.8080342,72.6947255 57.185794,72.3169658 57.6517842,72.3169658 Z M52.5892842,72.3169658 C53.0552745,72.3169658 53.4330342,72.6947255 53.4330342,73.1607158 L53.4330342,80.5446473 C53.4330342,81.0106375 53.0552745,81.3883973 52.5892842,81.3883973 C52.123294,81.3883973 51.7455342,81.0106375 51.7455342,80.5446473 L51.7455342,73.1607158 C51.7455342,72.6947255 52.123294,72.3169658 52.5892842,72.3169658 Z M47.84375,72 C48.3097403,72 48.6875,72.3777597 48.6875,72.84375 L48.6875,80.2276815 C48.6875,80.6936718 48.3097403,81.0714315 47.84375,81.0714315 C47.3777597,81.0714315 47,80.6936718 47,80.2276815 L47,72.84375 C47,72.3777597 47.3777597,72 47.84375,72 Z M65.6168853,72.3169658 C66.0828755,72.3169658 66.4606353,72.6947255 66.4606353,73.1607158 L66.4606353,77.2784179 C66.4606353,77.7444081 66.0828755,78.1221679 65.6168853,78.1221679 C65.150895,78.1221679 64.7731353,77.7444081 64.7731353,77.2784179 L64.7731353,73.1607158 C64.7731353,72.6947255 65.150895,72.3169658 65.6168853,72.3169658 Z M55.1205342,74.0044658 C55.5865245,74.0044658 55.9642842,74.3822255 55.9642842,74.8482158 L55.9642842,76.5357158 C55.9642842,77.001706 55.5865245,77.3794658 55.1205342,77.3794658 C54.654544,77.3794658 54.2767842,77.001706 54.2767842,76.5357158 L54.2767842,74.8482158 C54.2767842,74.3822255 54.654544,74.0044658 55.1205342,74.0044658 Z M50.0580342,72.3169658 C50.5240245,72.3169658 50.9017842,72.6947255 50.9017842,73.1607158 L50.9017842,74.8482158 C50.9017842,75.314206 50.5240245,75.6919658 50.0580342,75.6919658 C49.592044,75.6919658 49.2142842,75.314206 49.2142842,74.8482158 L49.2142842,73.1607158 C49.2142842,72.6947255 49.592044,72.3169658 50.0580342,72.3169658 Z",
    id: "Combined-Shape",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(83.000000, 45.000000)",
    fill: "#FF5458"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-204",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    points: "96 62.9 99.3 65.6 105 59"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "icon_arrow"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    d: "M19.523 4.076l-7.918 11.448 7.918 11.96"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "icon_errorpage"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M175.214 85.987c0 10.104-8.19 18.296-18.295 18.296h-36.59V67.692c0-10.104 8.19-18.295 18.295-18.295h36.59v36.59zm-36.59 0h18.295V67.692h-18.295v18.295zM52.636 60.374c0 10.104 8.19 18.295 18.295 18.295h36.59V42.08c0-10.105-8.19-18.295-18.295-18.295h-36.59v36.59zm36.59 0H70.932V42.08h18.296v18.295z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.358 32.017)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.8,
    height: 76.84,
    x: 13.721,
    fill: "#D8DFE6",
    rx: 3.659
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.59,
    height: 3.202,
    x: 24.699,
    y: 16.466,
    fill: "#FFF",
    rx: 1.601
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.59,
    height: 3.202,
    x: 24.699,
    y: 24.699,
    fill: "#FFF",
    rx: 1.601
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.699,
    height: 3.202,
    x: 24.699,
    y: 32.931,
    fill: "#FFF",
    rx: 1.601
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#81D39D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.187 76.84c-.577-5.014-.866-8.135-.866-9.363 0-1.843 3.06-22.099 3.06-25.177 0-3.079-.694-5.986-2.216-7.087-1.523-1.102-4.65-.63-4.173 6.499.217 3.246-1.844 21.466-1.844 23.125 0 1.734.476 3.134.476 4.008 0 1.14.249 3.805.747 7.995h4.816z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.313 76.84c2.53-7.492 3.795-11.98 3.795-13.463 0-2.226.953-4.015 1.918-5.425.964-1.41.964-4.74-.477-6.071-1.441-1.33-3.221-.447-3.9.998-.677 1.444-1.716 4.422-1.716 7.498 0 3.076-1.546 5.217-1.546 6.658 0 .96-.584 4.23-1.75 9.805h3.676z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.295 76.84c3.746-6.145 5.699-10.216 5.857-12.214.239-2.997 2.672-4.17 2.672-5.768 0-1.598 1.689-3.151 3.362-3.053 1.673.097 2.181 1.32 1.599 2.714-.377.9-.757 3.802-1.599 6.01-.46 1.208-1.673 2.472-1.673 2.472s-.965.728-1.69 1.938c-.64 1.071-2.04 3.705-4.2 7.9h-4.328zM27.443 76.835c.558-4.378 1.486-7.059 2.784-8.041 1.946-1.474 2.56-3.032 3.94-2.926 1.379.105 1.798 1.424 1.317 2.926-.31.97-.968 2.004-1.662 4.384-.38 1.303-2.263 3.662-2.263 3.662l-4.116-.005zM8.233 76.835c-.558-4.378-1.486-7.059-2.784-8.041-1.947-1.474-2.56-3.032-3.94-2.926-1.38.105-1.798 1.424-1.318 2.926.31.97.969 2.004 1.663 4.384.38 1.303 2.262 3.662 2.262 3.662l4.117-.005z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 36.59,
    height: 3.202,
    x: 24.699,
    y: 16.466,
    fill: "#FFF",
    rx: 1.601
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.59,
    height: 3.202,
    x: 24.699,
    y: 24.699,
    fill: "#FFF",
    rx: 1.601
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.227 36.59)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.249,
    height: 40.249,
    fill: "#F77676",
    rx: 20.125
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M15.332 24.324l8.993-8.992-8.993 8.992zM24.325 24.324l-8.993-8.992 8.993 8.992z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M22.46 16.979l.47.47-2.505 2.505 2.505 2.506-.47.47-2.506-2.505-2.505 2.505-.47-.47 2.505-2.506-2.505-2.505.47-.47 2.505 2.505 2.506-2.505z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#8E9299",
    d: "M147.26 45.47c-.14 1.113-.055 1.77.252 1.972.461.302 2.066.234 3.54.844.983.406 2.218.47 3.706.19.406-.507.387-.866-.058-1.075-.176-.083-.964.075-2.395-.923-.261-.182-.805-.485-1.405-1.029-.324-.293-.74-.656-1.246-1.088l-2.395 1.109zM139.596 48.19c-.632.928-.856 1.551-.674 1.87.274.477 1.737 1.142 2.774 2.35.691.807 1.764 1.422 3.218 1.846.595-.268.741-.596.44-.983-.12-.154-.895-.37-1.717-1.905-.15-.28-.497-.796-.784-1.55-.155-.408-.36-.919-.615-1.532l-2.642-.096z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A6DDA",
    d: "M120.807 27.583l-.72 3.771c11.382 1.626 17.439 2.416 18.17 2.368.467-.03 1.234 2.931 2.709 5.786.173.334 2.222 2.609 6.148 6.824l2.713-1.772c-2.838-4.094-4.547-6.972-5.125-8.634-1.106-3.18-1.825-5.494-3.05-6.27-2.183-1.383-8.697-3.131-19.543-5.244l-1.302 3.171z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F77676",
    d: "M128.167 14.345c-1.897 3.107-4.444 12.709-.148 13.623a43.098 43.098 0 0 0 11.07.897l-.255-2.44c-4.753-1.068-7.574-1.721-8.464-1.96-1.336-.356 3.726-10.007 2.903-11.17-.823-1.163-3.21-2.057-5.106 1.05z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    strokeLinecap: "round",
    strokeWidth: 2.744,
    d: "M134.759 26.446l8.02 3.403 6.789-8.907"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C85FF",
    d: "M119.68 25.95c-1.514 3.73-1.908 6.026-1.184 6.885 1.086 1.288 16.52.803 17.6 1.222.459.177-.06 2.288.074 5.659.089 2.247 1.067 5.33 2.934 9.246l3.271-.512c-.88-5.156-1.226-8.653-1.036-10.491.364-3.518.712-6.041-.11-7.321-1.468-2.284-7.764-4.662-18.889-7.133l-2.66 2.444z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    d: "M138.75 25.94c1.564-1.074 2.504-1.678 2.822-1.812.197-.083.31-.039.349.01.13.164-.138.533-.805 1.105l3.599-.131c.305.099.452.206.442.32-.033.394-.966.251-2.514.347-.046.003-.072.039-.079.108 2.11-.094 3.269-.08 3.474.04.036.022.157.123.169.22.013.116-.093.23-.192.264-.264.088-1.362.155-3.293.199-.038.074-.019.112.056.113 1.407.03 2.526-.009 2.777.096.152.064.173.167.175.26 0 .094-.025.182-.175.239-.257.097-1.159.113-2.704.049-.019.072-.007.107.035.107.957.002 1.634.018 1.938.09.224.055.078.393-.055.415-.536.09-2.38.035-5.533-.162l-.485-1.877z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F77676",
    d: "M118.815 33.534c.643.172 2.142.236 4.497.191 1.301-2.729 2.36-4.567 3.175-5.513.874-1.015 2.23-1.758 4.068-2.23-1.147-1.47-1.564-2.502-1.252-3.099 1.424-2.726 2.559-5.53 3.436-7.643.55-1.328.728-2.68.023-3.213-.737-.558-2.005-1.497-3.506-1.363-2.055.185-5.519 1.221-8.637 5.307-6.759 8.858-5.689 16.522-1.804 17.563z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E15A5A",
    d: "M124.87 14.05c-2.223 3.688-2.774 14.038 2.226 15.102 4.246.903 8.39.608 12.436-.885l-.287-2.887c-5.227.021-8.358-.107-9.395-.385-1.554-.418.81-9.927.36-11.483-.448-1.557-3.117-3.149-5.34.539z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M135.234 8.01c1.57.233 3.382.877 3.99 1.993.404.744.273 1.59-.394 2.538-.093.811-.156 1.279-.189 1.403-.033.124-.285.041-.756-.248-.686.751-1.338 1.097-1.955 1.04-.617-.058-1.503-.538-2.657-1.441a1.525 1.525 0 0 1-.653.392c-.36.103-.642.04-.898-.075-.683-.305-1.105-1.253-1.059-1.632.08-.644 3.001-4.203 4.571-3.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M139.124 10.972c.244.641.837.884 1.388.901.712.022 1.394-.366 1.603-1.106.37-1.314-1.12-1.104-1.677-2.018-.26-.427-.49-1.71-1.12-2.178-.722-.537-1.74-.557-2.143-.69-.754-.248-.73-.756-1.93-.769-.98-.01-1.804.34-2.416 1.795-.17.402-.304 1.17-.508 2.242a8.937 8.937 0 0 1-.202.756c.319.41.85.553 1.592.427.472-.08.728-.3.768-.655.029-.244-.066-.562.008-.756.072-.19.336-.357.568-.29.43.122.409.552.13 1.026a1.501 1.501 0 0 0-.096.315.38.38 0 0 0 .158.404.251.251 0 0 0 .351-.073c.581-.907 1.086-1.325 1.515-1.254.693.115 1.452.453 2.01 1.923z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38 78.67)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.202,
    cy: 3.202,
    r: 3.202,
    fill: "#C9DAFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.202,
    cy: 3.202,
    r: 1,
    fill: "#4C85FF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.42 8.233)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.202,
    cy: 3.202,
    r: 3.202,
    fill: "#C9DAFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.202,
    cy: 3.202,
    r: 1,
    fill: "#4C85FF"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 199.287,
    cy: 31.287,
    r: 2.287,
    fill: "#B5FECE"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(158.748 66.777)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.202,
    cy: 3.202,
    r: 3.202,
    fill: "#CFDEFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.202,
    cy: 3.202,
    r: 1,
    fill: "#4C85FF"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 157.376,
    cy: 31.559,
    r: 1,
    fill: "#4C85FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.064,
    cy: 11.434,
    r: 1,
    fill: "#4C85FF"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "icon_successpage"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M184,82a20,20,0,0,1-20,20H124V62a20,20,0,0,1,20-20h40Zm-40,0h20V62H144ZM50,54A13,13,0,0,0,63,67H89V41A13,13,0,0,0,76,28H50Zm26,0H63V41H76Z",
    style: {
      fill: "#f1f1f1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M103.06,102.45a142.24,142.24,0,0,0-23,.26q-8.75,1-14.06,4.34l-4,4.46q13.75-3.9,20.79-5.19T103.22,104Z",
    style: {
      fillRule: "evenodd",
      fill: "url(#ae8405fb-0101-4769-b557-7700962aced1)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 18,
    width: 63.19,
    height: 84,
    rx: 4,
    style: {
      fill: "#d8dfe6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5,35h29a1.5,1.5,0,0,1,1.5,1.5h0a1.5,1.5,0,0,1-1.5,1.5h-29A1.5,1.5,0,0,1,96,36.5h0A1.5,1.5,0,0,1,97.5,35Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5,26h2.73a1.5,1.5,0,1,1,0,3H110.5a1.5,1.5,0,0,1,0-3Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5,44h29a1.5,1.5,0,0,1,1.5,1.5h0a1.5,1.5,0,0,1-1.5,1.5h-29A1.5,1.5,0,0,1,96,45.5h0A1.5,1.5,0,0,1,97.5,44Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5,53h15a1.5,1.5,0,0,1,1.5,1.5h0a1.5,1.5,0,0,1-1.5,1.5h-15A1.5,1.5,0,0,1,96,54.5h0A1.5,1.5,0,0,1,97.5,53Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,58h0a22,22,0,0,1,22,22h0a22,22,0,0,1-22,22h0a22,22,0,0,1-22-22h0A22,22,0,0,1,143,58Z",
    style: {
      fill: "#81d39d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.1,83.06,148,75.49a.84.84,0,1,1,1.24,1.14h0l-8.09,8.88-3.81-3.88a.85.85,0,0,1,0-1.19.83.83,0,0,1,1.19,0l0,0Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.36,58.42a7.2,7.2,0,0,1,3.23-2.08c.84-.14,1.65-1,2.4-2.66,0-.34-.37-.41-1-.21-.39.12-2.14,2.06-2.13,1.34s.23-1.45,0-1.32a5.76,5.76,0,0,0-.88,1.86l-2.82,2.44Z",
    style: {
      fill: "#d8d8d8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,81.25a2.19,2.19,0,0,0-2.26,0c-1,.65-2.11,1.8-2.66,2.06a.87.87,0,0,1-1.07-.28L75.14,78a2.55,2.55,0,0,1,1.5.27,18.08,18.08,0,0,1,2.56,1.57L78,81.25ZM99.5,100a1.88,1.88,0,0,0,1.13,1.71c1,.45,2.59.85,3.09,1.16a.71.71,0,0,1,.27.94l-5.92-.22a2.08,2.08,0,0,1-.49-1.27,14,14,0,0,1,.13-2.62Z",
    style: {
      fill: "#333",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.19,49.24c.42-1.16,2.06-1.53,3-1.29.62.16,1.12.85,1.5,2.06a2.11,2.11,0,0,1,.51.71c0,.11-.14.15-.44.13a1.54,1.54,0,0,1-.27,1.6,2.82,2.82,0,0,1-2.11.41v.53a.51.51,0,0,1-.27.29,1.47,1.47,0,0,1-1.43-.1A7.53,7.53,0,0,1,94.19,49.24Z",
    style: {
      fill: "#d8d8d8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.62,66.08v36.29h5.94L100.73,67Z",
    style: {
      fill: "#de4545",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,65.49V77.91c0,1.78,0,5.93-3,5.34q-3-.6-13.12-5.34l-1.21,4.75q9.82,3.82,12.07,4.59C91,88,96.17,89.18,97.83,85q1.67-4.16,2.54-18.54l-6.34-1Z",
    style: {
      fill: "#f77676",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.83,53.25c-1.35.16-2,1.19-2,3.09v10.1l9,1.66-1.6-10c3.58,1.7,6.29,2.55,8.1,2.55s4.61-1.25,8.38-3.75l-1-1.84q-4.66,1.84-6.6,1.84T98.21,53.84Z",
    style: {
      fill: "#4c85ff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.11,48.19c-.23.55-.41.83-.55.85-.6.08-.28.39-.61,1.35-.65,1.94,2.67,12.23.61,14s-5.32.59-8.11,5.46-13.06.6-15.6-1.18-1.49-5.76.6-6.66,7,.92,8.66-.59,1.37-7.08,3.73-7.38,4.5.88,4.5-2.11.74-3.24,1.68-4.21,3.33-.54,3.93-.54C97.36,47.19,97.74,47.53,98.11,48.19Z",
    style: {
      fill: "#333",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M66.14,102q-.73-6.07-.74-7.57c0-1.49,2.6-17.85,2.6-20.34s-.59-4.84-1.88-5.73-4-.5-3.55,5.26C62.75,76.24,61,91,61,92.3s.41,2.53.41,3.24q0,1.38.63,6.46Z",
    style: {
      fill: "#81d39d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.92,102q3-9.21,3-11a8,8,0,0,1,1.53-4.45c.76-1.15.76-3.88-.38-5a1.9,1.9,0,0,0-3.1.81,16.05,16.05,0,0,0-1.37,6.15c0,2.52-1.23,4.28-1.23,5.46A71.14,71.14,0,0,1,66,102Zm.08,0q4.5-7.45,4.7-9.87c.19-2.42,2.14-3.37,2.14-4.66A2.68,2.68,0,0,1,78.53,85c1.34.08,1.75,1.07,1.28,2.2-.3.72-.6,3.07-1.28,4.85a7.35,7.35,0,0,1-1.34,2,6,6,0,0,0-1.35,1.57q-.78,1.29-3.37,6.38Zm7,0c.48-3.59,1.26-5.79,2.37-6.6,1.65-1.21,2.17-2.48,3.35-2.4s1.53,1.17,1.12,2.4A38.06,38.06,0,0,0,81.42,99a13.12,13.12,0,0,1-1.92,3Zm-15,0q-.7-5.39-2.37-6.6C57,94.19,56.46,92.92,55.28,93s-1.53,1.17-1.12,2.4A38.06,38.06,0,0,1,55.58,99a13.12,13.12,0,0,0,1.92,3Z",
    style: {
      fill: "#81d39d",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M114.36,58.42a7.2,7.2,0,0,1,3.23-2.08c.84-.14,1.65-1,2.4-2.66,0-.34-.37-.41-1-.21-.39.12-2.14,2.06-2.13,1.34s.23-1.45,0-1.32a5.76,5.76,0,0,0-.88,1.86l-2.82,2.44Z",
    style: {
      fill: "#d8d8d8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,81.25a2.19,2.19,0,0,0-2.26,0c-1,.65-2.11,1.8-2.66,2.06a.87.87,0,0,1-1.07-.28L75.14,78a2.55,2.55,0,0,1,1.5.27,18.08,18.08,0,0,1,2.56,1.57L78,81.25ZM99.5,100a1.88,1.88,0,0,0,1.13,1.71c1,.45,2.59.85,3.09,1.16a.71.71,0,0,1,.27.94l-5.92-.22a2.08,2.08,0,0,1-.49-1.27,14,14,0,0,1,.13-2.62Z",
    style: {
      fill: "#333",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.19,49.24c.42-1.16,2.06-1.53,3-1.29.62.16,1.12.85,1.5,2.06a2.11,2.11,0,0,1,.51.71c0,.11-.14.15-.44.13a1.54,1.54,0,0,1-.27,1.6,2.82,2.82,0,0,1-2.11.41v.53a.51.51,0,0,1-.27.29,1.47,1.47,0,0,1-1.43-.1A7.53,7.53,0,0,1,94.19,49.24Z",
    style: {
      fill: "#d8d8d8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.62,66.08v36.29h5.94L100.73,67Z",
    style: {
      fill: "#de4545",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,65.49V77.91c0,1.78,0,5.93-3,5.34q-3-.6-13.12-5.34l-1.21,4.75q9.82,3.82,12.07,4.59C91,88,96.17,89.18,97.83,85q1.67-4.16,2.54-18.54l-6.34-1Z",
    style: {
      fill: "#f77676",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.83,53.25c-1.35.16-2,1.19-2,3.09v10.1l9,1.66-1.6-10c3.58,1.7,6.29,2.55,8.1,2.55s4.61-1.25,8.38-3.75l-1-1.84q-4.66,1.84-6.6,1.84T98.21,53.84Z",
    style: {
      fill: "#4c85ff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.11,48.19c-.23.55-.41.83-.55.85-.6.08-.28.39-.61,1.35-.65,1.94,2.67,12.23.61,14s-5.32.59-8.11,5.46-13.06.6-15.6-1.18-1.49-5.76.6-6.66,7,.92,8.66-.59,1.37-7.08,3.73-7.38,4.5.88,4.5-2.11.74-3.24,1.68-4.21,3.33-.54,3.93-.54C97.36,47.19,97.74,47.53,98.11,48.19Z",
    style: {
      fill: "#333",
      fillRule: "evenodd"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 75.5,
    r: 3.5,
    style: {
      fill: "#c9daff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 75.5,
    r: 1,
    style: {
      fill: "#4c85ff"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 27.5,
    r: 2.5,
    style: {
      fill: "#b5fece"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 161.5,
    cy: 59.5,
    r: 3.5,
    style: {
      fill: "#cfdeff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.5,
    cy: 59.5,
    r: 1,
    style: {
      fill: "#4c85ff"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 69.5,
    cy: 18.5,
    r: 1,
    style: {
      fill: "#4c85ff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 47.5,
    r: 1,
    style: {
      fill: "#4c85ff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 4.5,
    r: 1,
    style: {
      fill: "#4c85ff"
    }
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "icon_cheque"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9995676,3.10627721 L14.1476721,2.96328062 L20.027859,9.05350889 L20,9.08040703 L20,21 C20,21.5522847 19.5522847,22 19,22 L5,22 C4.44771525,22 4,21.5522847 4,21 L4,4 C4,3.44771525 4.44771525,3 5,3 L13.9995676,3 L13.9995676,3.10627721 Z M13.9995676,4.24957898 L13.9995676,9.04898577 L18.6334512,9.04898577 L13.9995676,4.24957898 Z M19,10.0489858 L12.9995676,10.0489858 L12.9995676,4 L5,4 L5,21 L19,21 L19,10.0489858 Z M9.5,13 L14.5,13 C14.7761424,13 15,13.2238576 15,13.5 C15,13.7761424 14.7761424,14 14.5,14 L9.5,14 C9.22385763,14 9,13.7761424 9,13.5 C9,13.2238576 9.22385763,13 9.5,13 Z M9.5,15 L11.5,15 C11.7761424,15 12,15.2238576 12,15.5 C12,15.7761424 11.7761424,16 11.5,16 L9.5,16 C9.22385763,16 9,15.7761424 9,15.5 C9,15.2238576 9.22385763,15 9.5,15 Z",
    id: "Combined-Shape"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "icon_welcome"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 1228,
    height: 180,
    rx: 5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#5E6DEA",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 939.5,
    cy: -19.5,
    r: 182.5,
    fill: "#4D4BD9",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1080.5,
    cy: 95,
    fill: "#FF5458",
    mask: "url(#b)",
    rx: 16.5,
    ry: 16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1217.5,
    cy: 171.5,
    r: 68.5,
    fill: "#4D4BD9",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -34,
    cy: 81,
    r: 88,
    fill: "#4D4BD9",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.5,
    cy: 70.5,
    r: 10.5,
    fill: "#565EE3",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 616.5,
    cy: 44.5,
    r: 2.5,
    fill: "#FF5458",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(63 21)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2F0CB9",
    d: "M218 124c0 18.776-15.222 34-33.999 34H116V89.999C116 71.222 131.222 56 150 56h68v68zm-68 0h34V90h-34v34zM25 46.666C25 59.552 35.446 70 48.333 70H95V23.333C95 10.446 84.554 0 71.666 0H25v46.666zM71 46H48V23h23v23z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    width: 97.306,
    height: 129.36,
    x: 56.98,
    y: 30,
    fill: "#D8DFE6",
    rx: 6.16
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.28,
    height: 4.62,
    x: 81.62,
    y: 56.18,
    fill: "#FFF",
    rx: 2.31
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M103.95 42.32h4.199a2.31 2.31 0 1 1 0 4.62h-4.199a2.31 2.31 0 1 1 0-4.62z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.28,
    height: 4.62,
    x: 81.62,
    y: 70.04,
    fill: "#FFF",
    rx: 2.31
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.72,
    height: 4.62,
    x: 81.62,
    y: 83.9,
    fill: "#FFF",
    rx: 2.31
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46.2,
    height: 46.2,
    x: 130.02,
    y: 112.06,
    fill: "#81D39D",
    stroke: "#81D39D",
    strokeWidth: 1.54,
    rx: 23.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M150.36 140.165l10.78-11.834a1.32 1.32 0 0 1 1.952 1.778l-12.662 13.899-5.953-6.073a1.32 1.32 0 1 1 1.886-1.848l3.997 4.078z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M106.82 89.168c2.017-1.916 3.674-2.984 4.972-3.204 1.299-.22 2.532-1.587 3.7-4.102-.074-.518-.58-.625-1.518-.32-.598.193-3.293 3.175-3.274 2.064.02-1.112.35-2.224.035-2.037-.241.144-.691 1.103-1.35 2.877l-4.342 3.759 1.776.963z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M50.875 124.326c-1.35-.62-2.51-.597-3.479.067-1.453.996-3.24 2.763-4.09 3.168-.568.27-1.117.125-1.647-.436l4.755-7.792c.654-.125 1.427.015 2.32.42.892.406 2.205 1.213 3.938 2.422l-1.797 2.151zM83.93 153.15c.114 1.297.695 2.175 1.744 2.636 1.574.69 3.984 1.31 4.75 1.79.511.32.65.802.418 1.446l-9.108-.34c-.426-.448-.679-1.1-.758-1.955-.079-.855-.01-2.202.204-4.042l2.75.465z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M75.749 75.027c.65-1.779 3.172-2.359 4.616-1.987.962.248 1.733 1.309 2.31 3.181.47.427.742.687.82.78.077.094-.156.263-.701.51.292 1.087.15 1.906-.424 2.456s-1.657.76-3.25.632l.014.822a.8.8 0 0 1-.403.451c-.758.37-1.89.198-2.203-.158-.532-.607-1.43-4.909-.78-6.687z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE4545",
    d: "M77.952 100.968v55.887h9.15l-1.273-54.458z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F77676",
    d: "M75.505 100.054v19.127c0 2.741 0 9.138-4.688 8.224-3.125-.61-9.86-3.35-20.203-8.224l-1.851 7.31c10.077 3.926 16.272 6.283 18.585 7.07 3.47 1.181 11.453 2.982 14.016-3.415 1.71-4.264 3.013-13.78 3.91-28.55l-9.77-1.542z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C85FF",
    d: "M76.746 81.202c-2.085.254-3.127 1.84-3.127 4.76v15.558l13.825 2.561-2.469-15.359c5.523 2.613 9.68 3.92 12.473 3.92 2.793 0 7.098-1.923 12.914-5.768l-1.563-2.84c-4.791 1.894-8.178 2.84-10.16 2.84-1.983 0-7.55-1.586-16.702-4.758l-5.191-.914z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M82.804 73.449c-.325 1.782-1.864.687-1.864 1.981 0 1.957-.432 2.28-.93 3.754-1.014 2.993 8.209 12.344.93 19.19-7.28 6.845-8.192.914-12.488 8.415-4.296 7.5-20.105.914-24.022-1.828-3.917-2.741-2.289-8.872.928-10.243 3.217-1.37 10.816 1.409 13.326-.913 2.51-2.323 2.111-10.909 5.753-11.37 3.642-.46 6.926 1.354 6.926-3.251 0-4.606 1.589-6.39 3.837-7.517 2.248-1.126 7.928 0 7.604 1.782z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#81D39D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.628 159.36c-.756-6.239-1.134-10.122-1.134-11.65 0-2.294 4.006-27.498 4.006-31.33 0-3.83-.908-7.447-2.901-8.818-1.994-1.37-6.088-.783-5.464 8.087.284 4.04-2.415 26.711-2.415 28.775 0 2.158.624 3.9.624 4.988 0 1.419.326 4.735.978 9.948h6.306z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.922 159.36c3.097-9.46 4.646-15.126 4.646-16.999 0-2.81 1.167-5.069 2.348-6.85 1.181-1.78 1.181-5.985-.583-7.665-1.765-1.68-3.945-.564-4.775 1.26-.83 1.824-2.101 5.584-2.101 9.467 0 3.884-1.893 6.587-1.893 8.407 0 1.213-.715 5.34-2.144 12.38h4.502zM40.04 159.36c4.625-7.646 7.035-12.712 7.231-15.198.294-3.729 3.298-5.188 3.298-7.177 0-1.99 2.085-3.921 4.151-3.8 2.066.122 2.693 1.644 1.974 3.378-.465 1.12-.935 4.73-1.974 7.477-.57 1.504-2.066 3.077-2.066 3.077s-1.19.906-2.085 2.411c-.792 1.334-2.52 4.61-5.185 9.832H40.04zM50.82 159.354c.73-5.528 1.946-8.913 3.645-10.153 2.549-1.86 3.353-3.828 5.16-3.695 1.805.133 2.353 1.799 1.725 3.695-.407 1.225-1.269 2.53-2.177 5.535-.498 1.645-2.963 4.624-2.963 4.624l-5.39-.006zM27.72 159.354c-.73-5.528-1.946-8.913-3.645-10.153-2.549-1.86-3.353-3.828-5.16-3.695-1.805.133-2.353 1.799-1.725 3.695.407 1.225 1.269 2.53 2.177 5.535.498 1.645 2.963 4.624 2.963 4.624l5.39-.006z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 113.16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.39,
    cy: 5.39,
    r: 5.39,
    fill: "#C9DAFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.39,
    cy: 5.39,
    r: 1.078,
    fill: "#4C85FF"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 174.79,
    cy: 44.63,
    r: 3.85,
    fill: "#B5FECE"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(177.1 88.52)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.39,
    cy: 5.39,
    r: 5.39,
    fill: "#CFDEFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.39,
    cy: 5.39,
    r: 1.078,
    fill: "#4C85FF"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 30.77,
    cy: 83.77,
    r: 1.77,
    fill: "#FF5458"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 141,
    r: 3,
    fill: "#FF5458",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 24,
    r: 3,
    fill: "#FF5458",
    mask: "url(#b)"
  })))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "icon_profile"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M36.093 37.5a8.5 8.5 0 0 1 8.5 8.5.5.5 0 1 1-1 0 7.5 7.5 0 0 0-7.5-7.5H28a7.5 7.5 0 0 0-7.5 7.5.5.5 0 1 1-1 0 8.5 8.5 0 0 1 8.5-8.5zM32 18.5a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14z"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "icon_zero-list"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M173.886 48.59c0 10.104-8.191 18.296-18.295 18.296H119V30.295C119 20.19 127.19 12 137.296 12h36.59v36.59zm-36.59 0h18.294V30.295h-18.295V48.59zM49 58.59c0 10.104 8.19 18.296 18.295 18.296h36.59V40.295C103.886 30.19 95.696 22 85.59 22H49v36.59zm36.59 0H67.295V40.295H85.59V58.59z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(73 42)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 63,
    fill: "#D8DFE6",
    rx: 9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4CED9",
    d: "M56.5 22H81v19H56.5a9.5 9.5 0 0 1 0-19z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 32,
    r: 3,
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#81D39D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.187 105.079c-.577-5.014-.866-8.135-.866-9.363 0-1.843 3.06-22.099 3.06-25.177 0-3.079-.694-5.986-2.216-7.087-1.523-1.102-4.65-.63-4.173 6.499.217 3.246-1.844 21.466-1.844 23.125 0 1.734.476 3.134.476 4.008 0 1.14.249 3.805.747 7.995h4.816z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.313 105.079c2.53-7.492 3.795-11.98 3.795-13.463 0-2.225.953-4.015 1.918-5.425.964-1.41.964-4.74-.477-6.071-1.441-1.33-3.221-.447-3.9.998-.677 1.444-1.716 4.422-1.716 7.498 0 3.076-1.546 5.217-1.546 6.658 0 .961-.584 4.23-1.75 9.805h3.676z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.295 105.079c3.746-6.145 5.699-10.216 5.857-12.214.239-2.997 2.672-4.169 2.672-5.768 0-1.598 1.689-3.15 3.362-3.053 1.673.098 2.181 1.32 1.599 2.714-.377.9-.757 3.802-1.599 6.01-.46 1.208-1.673 2.472-1.673 2.472s-.965.728-1.69 1.938c-.64 1.071-2.04 3.705-4.2 7.901h-4.328zM100.443 105.075c.558-4.38 1.486-7.06 2.784-8.042 1.946-1.473 2.56-3.031 3.94-2.926 1.379.105 1.798 1.424 1.317 2.926-.31.97-.968 2.004-1.662 4.384-.38 1.303-2.263 3.662-2.263 3.662l-4.116-.004zM81.233 105.075c-.558-4.38-1.486-7.06-2.784-8.042-1.947-1.473-2.56-3.031-3.94-2.926-1.38.105-1.798 1.424-1.318 2.926.31.97.969 2.004 1.663 4.384.38 1.303 2.262 3.662 2.262 3.662l4.117-.004z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#F77676",
    rx: 14,
    transform: "translate(55 78)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8E9299",
    d: "M163.393 53.955c-.139 1.113-.054 1.77.253 1.972.461.302 2.066.234 3.54.843.983.407 2.218.47 3.706.191.406-.508.387-.866-.058-1.075-.177-.083-.964.075-2.396-.924-.26-.181-.805-.485-1.404-1.028-.324-.294-.74-.656-1.246-1.088l-2.395 1.109zM155.73 56.675c-.632.928-.856 1.551-.674 1.87.274.477 1.737 1.141 2.774 2.35.691.806 1.764 1.422 3.218 1.846.595-.269.74-.596.439-.984-.12-.153-.894-.369-1.716-1.904-.15-.28-.497-.796-.784-1.55-.156-.409-.36-.92-.616-1.532l-2.641-.096z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A6DDA",
    d: "M136.94 36.068l-.718 3.771c11.381 1.626 17.438 2.415 18.17 2.368.466-.03 1.233 2.931 2.708 5.785.172.334 2.222 2.61 6.148 6.825l2.713-1.772c-2.838-4.095-4.547-6.973-5.125-8.634-1.107-3.18-1.825-5.494-3.05-6.27-2.183-1.383-8.697-3.131-19.543-5.244l-1.303 3.171z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F77676",
    d: "M144.3 22.83c-1.896 3.107-4.443 12.708-.147 13.622a43.098 43.098 0 0 0 11.07.897l-.255-2.439c-4.753-1.068-7.574-1.721-8.465-1.96-1.335-.357 3.727-10.007 2.904-11.17-.823-1.164-3.21-2.057-5.106 1.05z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    strokeLinecap: "round",
    strokeWidth: 2.744,
    d: "M150.893 34.93l8.02 3.404 6.789-8.907"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C85FF",
    d: "M135.813 34.434c-1.513 3.732-1.908 6.027-1.183 6.885 1.086 1.288 16.52.804 17.6 1.222.459.178-.06 2.288.074 5.66.088 2.247 1.067 5.33 2.934 9.246l3.271-.512c-.881-5.156-1.227-8.653-1.036-10.492.363-3.517.712-6.04-.111-7.32-1.467-2.285-7.763-4.662-18.888-7.133l-2.661 2.444z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    d: "M154.885 34.425c1.563-1.074 2.503-1.678 2.82-1.812.198-.083.311-.039.35.01.13.164-.138.532-.805 1.104l3.598-.13c.305.098.453.205.443.32-.033.394-.966.251-2.514.347-.046.003-.072.039-.079.108 2.11-.094 3.269-.08 3.474.04.036.022.157.123.169.22.013.116-.093.23-.192.264-.264.088-1.362.154-3.294.199-.037.074-.018.111.057.113 1.407.03 2.526-.01 2.777.096.152.064.173.167.174.259.002.095-.024.183-.174.24-.257.097-1.159.113-2.705.049-.018.071-.006.107.036.107.957.002 1.634.018 1.938.09.224.054.078.393-.055.415-.536.09-2.38.035-5.533-.163l-.485-1.876z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F77676",
    d: "M134.949 42.018c.643.173 2.142.237 4.497.192 1.301-2.73 2.36-4.567 3.175-5.513.874-1.015 2.23-1.759 4.068-2.231-1.147-1.469-1.564-2.502-1.252-3.098 1.424-2.726 2.559-5.53 3.436-7.643.55-1.328.728-2.68.023-3.213-.737-.558-2.005-1.497-3.506-1.363-2.055.185-5.519 1.221-8.637 5.307-6.759 8.857-5.69 16.521-1.804 17.562z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E15A5A",
    d: "M141.004 22.536c-2.223 3.687-2.774 14.036 2.226 15.1 4.245.904 8.39.61 12.435-.884l-.287-2.887c-5.226.021-8.358-.107-9.394-.386-1.555-.417.81-9.926.36-11.483-.449-1.556-3.118-3.148-5.34.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M151.368 16.495c1.57.232 3.382.876 3.99 1.993.404.744.272 1.59-.394 2.537-.093.812-.156 1.28-.19 1.404-.032.124-.284.041-.755-.248-.686.75-1.338 1.097-1.955 1.04-.617-.058-1.503-.539-2.657-1.442a1.525 1.525 0 0 1-.654.393c-.36.103-.641.04-.897-.075-.683-.305-1.106-1.253-1.06-1.632.08-.644 3.002-4.203 4.572-3.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M155.258 19.456c.243.642.837.885 1.388.902.712.022 1.394-.366 1.603-1.106.37-1.314-1.12-1.104-1.677-2.019-.26-.426-.49-1.71-1.12-2.178-.722-.536-1.74-.556-2.143-.69-.755-.248-.73-.756-1.93-.768-.98-.01-1.804.34-2.417 1.795-.169.402-.304 1.17-.507 2.242a8.937 8.937 0 0 1-.203.756c.32.41.85.553 1.593.427.472-.08.727-.3.768-.656.028-.243-.066-.561.007-.755.073-.19.337-.357.569-.29.43.122.409.552.13 1.025a1.501 1.501 0 0 0-.096.316.38.38 0 0 0 .158.404.251.251 0 0 0 .351-.074c.581-.906 1.086-1.324 1.515-1.253.692.115 1.452.452 2.01 1.922z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38 78.67)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.202,
    cy: 3.202,
    r: 3.202,
    fill: "#C9DAFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.202,
    cy: 3.202,
    r: 1,
    fill: "#4C85FF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.42 8.233)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.202,
    cy: 3.202,
    r: 3.202,
    fill: "#C9DAFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.202,
    cy: 3.202,
    r: 1,
    fill: "#4C85FF"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 199.287,
    cy: 31.287,
    r: 2.287,
    fill: "#B5FECE"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(158.748 66.777)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.202,
    cy: 3.202,
    r: 3.202,
    fill: "#CFDEFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.202,
    cy: 3.202,
    r: 1,
    fill: "#4C85FF"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 157.376,
    cy: 31.559,
    r: 1,
    fill: "#4C85FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.064,
    cy: 11.434,
    r: 1,
    fill: "#4C85FF"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.5 88.5l-.016 9.38M64.852 94.56l4.632 3.32 4.483-3.32"
  }))))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "icon_zero-clients"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M190 61.333C190 68.881 183.881 75 176.334 75H149V47.666C149 40.12 155.119 34 162.667 34H190v27.333zM162 62h14V48h-14v14zM33 80c0 11.597 9.402 21 21 21h42V59c0-11.598-9.402-21-21-21H33v42zm42 0H54V59h21v21z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 22,
    fill: "#D8DFE6",
    rx: 4,
    transform: "translate(73 53)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 22,
    fill: "#D8DFE6",
    rx: 4,
    transform: "translate(73 27)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.59,
    height: 3.202,
    x: 100,
    y: 36,
    fill: "#C4CED9",
    rx: 1.601
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.59,
    height: 3.202,
    x: 100,
    y: 62,
    fill: "#C4CED9",
    rx: 1.601
  }), /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 22,
    fill: "#D8DFE6",
    rx: 4,
    transform: "translate(73 79)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    x: 62,
    y: 77,
    fill: "#F77676",
    rx: 15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M78.22 92.72a3.78 3.78 0 0 1 3.775 3.585L82 96.5h-9a3.78 3.78 0 0 1 3.78-3.78h1.44zM77.09 86a2.455 2.455 0 0 1 2.455 2.455v.13a2.455 2.455 0 1 1-4.909 0v-.13A2.455 2.455 0 0 1 77.091 86z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    x: 80,
    y: 32,
    fill: "#4C85FF",
    rx: 6.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.59,
    height: 3.202,
    x: 100,
    y: 87,
    fill: "#C4CED9",
    rx: 1.601
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    x: 80,
    y: 58,
    fill: "#4C85FF",
    rx: 6.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22 83)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.202,
    cy: 3.202,
    r: 3.202,
    fill: "#C9DAFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.202,
    cy: 3.202,
    r: 1,
    fill: "#4C85FF"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M86.74 38.24a1.26 1.26 0 0 1 1.253 1.131L88 39.5h-3c0-.696.564-1.26 1.26-1.26h.48zM86.364 36c.452 0 .818.366.818.818v.044a.818.818 0 0 1-1.637 0v-.044c0-.452.367-.818.819-.818zM86.74 64.24a1.26 1.26 0 0 1 1.253 1.131L88 65.5h-3c0-.696.564-1.26 1.26-1.26h.48zM86.364 62c.452 0 .818.366.818.818v.044a.818.818 0 0 1-1.637 0v-.044c0-.452.367-.818.819-.818z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.42 8.233)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.202,
    cy: 3.202,
    r: 3.202,
    fill: "#C9DAFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.202,
    cy: 3.202,
    r: 1,
    fill: "#4C85FF"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 187.287,
    cy: 17.287,
    r: 2.287,
    fill: "#B5FECE"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(187 82)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.202,
    cy: 3.202,
    r: 3.202,
    fill: "#CFDEFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.202,
    cy: 3.202,
    r: 1,
    fill: "#4C85FF"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 169.457,
    cy: 26.457,
    r: 1,
    fill: "#4C85FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.457,
    cy: 17.457,
    r: 1,
    fill: "#4C85FF"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#81D39D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.187 101.079c-.577-5.014-.866-8.135-.866-9.363 0-1.843 3.06-22.099 3.06-25.177 0-3.079-.694-5.986-2.216-7.087-1.523-1.102-4.65-.63-4.173 6.499.217 3.246-1.844 21.466-1.844 23.125 0 1.734.476 3.134.476 4.008 0 1.14.249 3.805.747 7.995h4.816z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.313 101.079c2.53-7.492 3.795-11.98 3.795-13.463 0-2.225.953-4.015 1.918-5.425.964-1.41.964-4.74-.477-6.071-1.441-1.33-3.221-.447-3.9.998-.677 1.444-1.716 4.422-1.716 7.498 0 3.076-1.546 5.217-1.546 6.658 0 .961-.584 4.23-1.75 9.805h3.676z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.295 101.079c3.746-6.145 5.699-10.216 5.857-12.214.239-2.997 2.672-4.169 2.672-5.768 0-1.598 1.689-3.15 3.362-3.053 1.673.098 2.181 1.32 1.599 2.714-.377.9-.757 3.802-1.599 6.01-.46 1.208-1.673 2.472-1.673 2.472s-.965.728-1.69 1.938c-.64 1.071-2.04 3.705-4.2 7.901h-4.328zM168.443 101.075c.558-4.38 1.486-7.06 2.784-8.042 1.946-1.473 2.56-3.031 3.94-2.926 1.379.105 1.798 1.424 1.317 2.926-.31.97-.968 2.004-1.662 4.384-.38 1.303-2.263 3.662-2.263 3.662l-4.116-.004zM149.233 101.075c-.558-4.38-1.486-7.06-2.784-8.042-1.947-1.473-2.56-3.031-3.94-2.926-1.38.105-1.798 1.424-1.318 2.926.31.97.969 2.004 1.663 4.384.38 1.303 2.262 3.662 2.262 3.662l4.117-.004z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "icon_loading-data"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43,84.33A23.67,23.67,0,0,0,66.67,108H114V60.67A23.67,23.67,0,0,0,90.33,37H43ZM89,86H65V62H89Zm98,10.67A11.33,11.33,0,0,1,175.67,108H153V85.33A11.33,11.33,0,0,1,164.33,74H187ZM165,97h11V86H165Z",
    style: {
      fill: "#f1f1f1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.1,37.22A27.49,27.49,0,1,1,133.5,29a5.36,5.36,0,0,1,.17,10.71h-.17A16.82,16.82,0,1,0,145.69,45l-.22-.24a5.35,5.35,0,0,1,7.63-7.51Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.34,107q-1.05-9.48-1.06-11.79c0-2.32,3.72-27.84,3.72-31.72s-.84-7.53-2.69-8.92-5.65-.79-5.07,8.18c.26,4.09-2.24,27-2.24,29.13s.58,4,.58,5.05c0,1.44.3,4.79.91,10.07Z",
    style: {
      fill: "#81d39d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.75,107q4.91-14,4.9-16.82a11.72,11.72,0,0,1,2.48-6.78c1.25-1.76,1.25-5.92-.62-7.58s-4.16-.56-5,1.24a23.15,23.15,0,0,0-2.22,9.37c0,3.84-2,6.52-2,8.32q0,1.8-2.26,12.25Zm.25,0q7-11.39,7.26-15.09c.29-3.71,3.31-5.16,3.31-7.13A4.13,4.13,0,0,1,101.73,81c2.08.13,2.7,1.64,2,3.36-.46,1.11-.93,4.7-2,7.43a11.25,11.25,0,0,1-2.07,3,9.08,9.08,0,0,0-2.09,2.4q-1.2,2-5.21,9.76Z",
    style: {
      fill: "#81d39d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,107q1-8.37,3.38-10.25c2.37-1.88,3.11-3.87,4.79-3.73s2.18,1.81,1.6,3.73c-.38,1.24-1.18,2.55-2,5.59A20.88,20.88,0,0,1,101,107Zm-22,0q-1-8.37-3.38-10.25c-2.37-1.88-3.11-3.87-4.79-3.73s-2.18,1.81-1.6,3.73c.38,1.24,1.18,2.55,2,5.59A20.88,20.88,0,0,0,69,107Z",
    style: {
      fill: "#70c38d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 26.2,
    cy: 85.2,
    r: 3.2,
    style: {
      fill: "#c9daff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.2,
    cy: 85.2,
    r: 1,
    style: {
      fill: "#4c85ff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 89.2,
    cy: 18.2,
    r: 3.2,
    style: {
      fill: "#c9daff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.2,
    cy: 18.2,
    r: 1,
    style: {
      fill: "#4c85ff"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 184.29,
    cy: 39.29,
    r: 2.29,
    style: {
      fill: "#b5fece"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 174.2,
    cy: 76.2,
    r: 3.2,
    style: {
      fill: "#cfdeff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.2,
    cy: 76.2,
    r: 1,
    style: {
      fill: "#4c85ff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M110.85,108.9q8.34-.6,10.74-.6t7.48.21l1.11,1.54-19.44-.68Z",
    style: {
      fillRule: "evenodd",
      fill: "url(#faa6274e-db62-4ee4-bcdd-6024a20950a5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.15,109.5a63,63,0,0,1,8.54,1,14,14,0,0,1,5,1.89l1.29,1.53q-4.94-1.73-7.5-2.4T133,110Z",
    style: {
      fillRule: "evenodd",
      fill: "url(#b5ca78ea-367e-492b-a496-5df9438402f0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.13,111a63.16,63.16,0,0,1,8.54,1,13.89,13.89,0,0,1,5,1.89l1.3,1.53q-5-1.73-7.5-2.4t-7.5-1.5Z",
    style: {
      fillRule: "evenodd",
      fill: "url(#be722d66-3a0f-4b35-b156-c18762fd8571)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.45,107.11a1.1,1.1,0,0,1-.43,1.06c-.48.33-1.24.67-1.46.88a.44.44,0,0,0-.06.56l3-.54a1.35,1.35,0,0,0,.14-.77,9,9,0,0,0-.28-1.49Zm6.73.6a1.1,1.1,0,0,1-.43,1.06c-.48.33-1.24.67-1.46.88a.44.44,0,0,0-.06.56l3-.54a1.35,1.35,0,0,0,.14-.77,9,9,0,0,0-.28-1.49Z",
    style: {
      fill: "#333",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.49,92.49Q109.72,99,110.14,102a31.68,31.68,0,0,0,1.5,6.07L114,108a43.14,43.14,0,0,1-1.06-6.9q0-1.72,1.93-7.8Z",
    style: {
      fill: "#f77676",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.88,89.91a3.73,3.73,0,0,0-1.65-1c-.43-.07-.84-.52-1.23-1.34,0-.17.2-.21.51-.11s1.09,1,1.08.68-.11-.73,0-.67a3,3,0,0,1,.45.94l1.44,1.24-.59.31Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.66,92.18a3.65,3.65,0,0,0-1.9.49c-.34.26-1,.26-1.82,0-.11-.14,0-.28.26-.44s1.52-.09,1.24-.33-.61-.42-.5-.45a2.85,2.85,0,0,1,1,.32l1.89-.21-.17.64Z",
    style: {
      fill: "#d8d8d8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.34,90.62a3.71,3.71,0,0,0,1.88.56c.43-.05,1,.27,1.55,1q0,.26-.45.24c-.21,0-1.34-.7-1.23-.36s.31.67.19.64-.32-.28-.69-.78l-1.73-.79.48-.47Z",
    style: {
      fill: "#d8d8d8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.27,107.85a1,1,0,0,1-.57.87c-.52.22-1.32.43-1.57.59a.35.35,0,0,0-.14.47l3-.11a1.07,1.07,0,0,0,.25-.64,7.84,7.84,0,0,0-.07-1.33l-.91.15Zm4.47,1.5a.94.94,0,0,1-.28,1c-.42.37-1.11.81-1.31,1a.36.36,0,0,0,0,.49l2.82-1a1,1,0,0,0,0-.69,7.56,7.56,0,0,0-.47-1.24Z",
    style: {
      fill: "#333",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.27,82.08a1.37,1.37,0,0,0-1.53-.65c-.31.08-.57.43-.76,1-.17.18-.26.3-.26.35s.07.08.22.07a.77.77,0,0,0,.14.8,1.38,1.38,0,0,0,1.07.21v.27a.28.28,0,0,0,.13.15.75.75,0,0,0,.73,0A3.9,3.9,0,0,0,138.27,82.08Z",
    style: {
      fill: "#d8d8d8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.54,90.6V109h-3l.42-17.88Z",
    style: {
      fill: "#de4545",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.36,90.3q1.21,9.28,1.22,10.18a26.56,26.56,0,0,0,1,4.58c.24.91.54,2.52.89,4.83l-2.53.09a77.13,77.13,0,0,0-2.5-9.8c-.56-1.4-1-4.53-1.29-9.37l3.23-.51Z",
    style: {
      fill: "#f77676",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,84c.69.08,1,.6,1,1.56V93.3h-5.11l.9-4.65a10.59,10.59,0,0,1-2.41,2A25.18,25.18,0,0,1,127.81,93l-.37-1.2q1.92-1.3,3.78-2.7a48.18,48.18,0,0,0,5.08-4.8L138,84Z",
    style: {
      fill: "#4c85ff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.19,81.56c.12.27.21.42.28.42.31,0,.15.2.31.68.34,1-1.35,6.19-.31,7.09s2.71.3,4.13,2.76,6.63.3,7.92-.6a2,2,0,0,0-.3-3.36c-1.06-.45-3.57.46-4.4-.3s-.7-3.58-1.9-3.73-2.29.44-2.29-1.07-.37-1.64-.85-2.13-1.69-.27-2-.27-.4.17-.59.51Z",
    style: {
      fill: "#333",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.5,93.3l3.94,15.6,2.07-.6q-.57-3.47-1-8.15A41.79,41.79,0,0,0,118,92.1Z",
    style: {
      fill: "#f77676",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.4,87.9q4.56,2.1,5.2,1.5c.65-.6,1.48-4.29,2.16-5.23a3.82,3.82,0,0,1,2.13-1.67,8,8,0,0,1,4.67,0c2.13.58,3.52,3.3,6.23,5.1l4.59,3-.64,2.1-5.8-3.28-3.48-3.06,2.08,7.84-8,1.2-.51-8.47q-2,5-3,5t-6.68-2.7Z",
    style: {
      fill: "#4c85ff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.58,83.1c1,0,1.32-.39,1.17-.7,0-.12-.15-.42-1.07-.33a3.77,3.77,0,0,0-1.11.26C111.57,82.84,111.9,83.1,112.58,83.1Z",
    style: {
      fill: "#87adff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M112.82,79.83a2,2,0,0,0-2.18-.41c-.38.18-.6.66-.64,1.45a1.17,1.17,0,0,0-.22.49c0,.07.11.08.31,0a1,1,0,0,0,.44.93,2,2,0,0,0,1.45,0l.08.33a.35.35,0,0,0,.22.14,1,1,0,0,0,.93-.24c.07-.12-.17-.4-.2-.87S113.09,80.19,112.82,79.83Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.54,80.26c-.55.38-1.05-.21-.84-.79.14-.38.48-.48,1-.32a.77.77,0,0,1,.73-.46,1.17,1.17,0,0,1,1,.39c.07.09.33,0,.74.28a1.13,1.13,0,0,1,.35,1,4.85,4.85,0,0,1-.43,1.35c-.27.11-.45.06-.55-.16s.48-.84.16-1-.29,0-.24.33l-.42.24c0-.54-.1-.86-.27-.95A1,1,0,0,0,110.54,80.26Z",
    style: {
      fill: "#323232",
      fillRule: "evenodd"
    }
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 160.38,
    cy: 32.33,
    r: 1,
    style: {
      fill: "#4c85ff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.06,
    cy: 14.2,
    r: 1,
    style: {
      fill: "#4c85ff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 28.5,
    r: 3.5,
    style: {
      fill: "#4c85ff"
    }
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "icon_error-data"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(13.712 8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M10.288 63.333C10.288 80.269 24.018 94 40.954 94h61.334V32.666C102.288 15.729 88.558 2 71.621 2H10.288v61.333zm60.505.83H40.126V33.494h30.667v30.667z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.788,
    cy: 31.5,
    r: 4.5,
    fill: "#4C85FF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M187.288 48c0 11.045-8.954 20-19.999 20h-40V28c0-11.046 8.953-20 20-20h40v40zm-39.452.274h19.726V28.548h-19.726v19.726z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.288 30)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#81D39D",
    d: "M56.441 77.32c14.388 0 29.7 5.536 39.916 3.855 12.492-2.056 24.666-5.922 35.98-6.602 25.017-1.504 44.435.55 43.93-12.832-.235-6.219-21.933-16.052-83.197-16.052C31.805 45.69.094 55.714.094 61.933c0 6.22-4.918 15.387 56.347 15.387z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.446)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4379EC",
    d: "M9.979 50.08c-.113 7.78 1.821 17.218 18.803 17.947 9.259.398 8.483-5.146 18.502-4.732 22.504.93 48.377 5.72 58.899.824 17.055-7.936 17.055-34.223 0-50.446C78.575-12.586 10.723-1.123 9.979 50.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C85FF",
    d: "M20.521 13.16c-.392 0-11.027 6.41-15.434 29.506-.928 4.863-.928 18.576 30.426 17.01 21.644-1.082 30.515-5.184 30.527-15.025.017-14.531-22.338-33.541-22.496-33.541-1.041 0-3.568 2.574-7.579 7.722l-7.809.355c-4.828-4.019-7.374-6.028-7.635-6.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4379EC",
    d: "M50.742 44.61c5.836-3.678-1.607-6.7-3.37-8.877-1.762-2.177-5.708-7.05-11.565-2.307-5.856 4.742-1.45 9.457.313 11.634 1.763 2.176 8.786 3.226 14.622-.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F77676",
    d: "M33.25 44.13l1.527-.161a1 1 0 0 1 .937 1.548l-.667 1.003a1 1 0 0 1-1.532.16l-.86-.841a1 1 0 0 1 .594-1.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9BBBFF",
    d: "M21.695 18.337c2.386 2.033 3.561 3.383 3.526 4.05-.044.844-1.443-.012-3.097.79-1.571.76-2.272 1.059-3.057.506-.393-.277.483-2.06 2.628-5.346zM43.527 17.57c-2.373 1.869-3.469 3.024-3.287 3.466.324.79 1.677.384 3.287 1.27 1.53.843 1.714 1.128 2.526.616.407-.256-.435-2.04-2.526-5.352z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 43.054 36.518)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.868,
    cy: 2.997,
    fill: "#FFF",
    rx: 2.868,
    ry: 2.997
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.086,
    cy: 3.269,
    fill: "#3C3C58",
    rx: 1.043,
    ry: 1.09
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.273,
    cy: 35.042,
    fill: "#4379EC",
    rx: 6.617,
    ry: 6.602
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4379EC",
    d: "M12.277 22.583C8.72 30.782 6.874 35.804 6.74 37.649c-.8 11.009 3.085 11.458 3.282 13.1.514 4.257 3.554 4.016 5.985 4.328 6.288.804 5.726-.882 10.825 1.517 3.4 1.6 4.248 4.189 2.546 7.77-18.015 2.263-27.257 2.263-27.724 0-2.998-14.532.543-28.459 10.623-41.781zM65.712 27.547c2.052 11 2.052 17.166 0 18.502-3.077 2.004-11.059 2.839-20.446 6.323-9.388 3.484-12.011 10.472-4.336 10.472 2.128 0 6.143 1.81 10.222 2.255 10.63 1.159 24.256 1.324 25.143-2.255 1.228-4.951 3.077-32.659-6.94-47.97-6.68-10.207-7.894-5.983-3.643 12.673z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4379EC",
    strokeLinecap: "round",
    d: "M25.166 40.819c1.462 1.1 2.84 1.1 4.135 0"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.283,
    cy: 5.746,
    fill: "#4C85FF",
    rx: 5.376,
    ry: 5.364
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C85FF",
    d: "M109.651 1.358c-4.744 1.894 3.07 6.803-.004 11.206-1.264 1.809-5.705 1.648-5.708 7.09 0 2.73 5.216 4.575 9.44 3.21 4.195-1.355 6.847-4.759 7.398-8.087C122.354 5.26 113.63-.23 109.651 1.358zM132.652 12.985c-6.908.38.868 10.154-5.032 14.512-2.425 1.79-8.024-.36-10.467 6.686-1.226 3.535 4.607 8.207 10.613 8.286 5.965.079 10.879-3.17 13.076-7.24 6.28-11.636-2.399-22.561-8.19-22.244z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#81D39D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.67 99c-2.768-8.342-4.152-13.35-4.152-15.026 0-2.514-1.034-4.535-2.08-6.128-1.045-1.593-1.045-5.354.517-6.857 1.563-1.503 3.493-.505 4.228 1.127.735 1.632 1.86 4.995 1.86 8.47 0 3.473 1.677 5.892 1.677 7.52 0 1.085.646 4.717 1.937 10.894h-3.986zM148.446 99c-3.678-6.717-5.595-11.168-5.751-13.352-.234-3.276-2.623-4.558-2.623-6.305 0-1.748-1.659-3.445-3.302-3.338-1.643.107-2.142 1.444-1.57 2.967.37.984.743 4.156 1.57 6.57.453 1.32 1.643 2.702 1.643 2.702s.948.796 1.659 2.119c.63 1.171 2.004 4.05 4.124 8.637h4.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.551 98.995c-.627-4.587-1.672-7.395-3.132-8.424-2.19-1.544-2.88-3.176-4.433-3.066-1.552.11-2.023 1.492-1.483 3.066.35 1.016 1.09 2.1 1.871 4.592.428 1.366 2.546 3.837 2.546 3.837l4.631-.005zM156.867 98.995c.571-4.587 1.52-7.395 2.848-8.424 1.99-1.544 2.619-3.176 4.03-3.066 1.41.11 1.839 1.492 1.348 3.066-.318 1.016-.991 2.1-1.7 4.592-.39 1.366-2.315 3.837-2.315 3.837l-4.21-.005z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.243 99c.678-5.404 1.017-8.78 1.017-10.127 0-2.02-3.13-24.231-3.13-27.607 0-3.375.71-6.563 2.267-7.77 1.557-1.209 4.755-.69 4.268 7.126-.222 3.56 1.886 23.538 1.886 25.356 0 1.902-.487 3.437-.487 4.395 0 1.25-.298 4.126-.895 8.627h-4.926z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#70C38D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.944 97c3.525-11.242 5.288-17.991 5.288-20.25 0-3.386 1.316-6.11 2.648-8.257 1.331-2.147 1.331-7.215-.658-9.24-1.99-2.025-4.448-.68-5.384 1.518-.936 2.2-2.37 6.732-2.37 11.414 0 4.681-2.134 7.94-2.134 10.134 0 1.463-.822 6.356-2.466 14.681h5.076z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.788 97c4.925-9.149 7.492-15.21 7.701-18.185.313-4.461 3.512-6.207 3.512-8.587s2.22-4.691 4.42-4.546c2.2.146 2.868 1.967 2.102 4.041-.494 1.34-.995 5.66-2.101 8.947-.606 1.8-2.2 3.681-2.2 3.681s-1.269 1.085-2.22 2.886c-.844 1.595-2.685 5.516-5.523 11.763h-5.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.988 96.994c.834-6.248 2.22-10.073 4.16-11.474 2.908-2.102 3.825-4.325 5.886-4.175 2.06.15 2.686 2.032 1.969 4.175-.464 1.384-1.448 2.86-2.484 6.255-.568 1.86-3.38 5.225-3.38 5.225l-6.15-.006zM39.948 96.994c-.722-6.248-1.924-10.073-3.604-11.474-2.52-2.102-3.316-4.325-5.102-4.175-1.786.15-2.328 2.032-1.706 4.175.402 1.384 1.254 2.86 2.153 6.255.492 1.86 2.93 5.225 2.93 5.225l5.33-.006zM46.909 97c-.924-7.167-1.386-11.643-1.386-13.43 0-2.679 4.265-32.132 4.265-36.608 0-4.477-.967-8.703-3.09-10.305-2.122-1.602-6.482-.915-5.818 9.45.302 4.72-2.572 31.213-2.572 33.625 0 2.522.664 4.557.664 5.828 0 1.658.407 5.471 1.22 11.44h6.717z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 152.788,
    cy: 6.5,
    r: 4.5,
    fill: "#B5FECE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 182.288,
    cy: 38,
    r: 1,
    fill: "#4C85FF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.288 5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.807,
    cy: 5.5,
    fill: "#CFDEFF",
    rx: 5.807,
    ry: 5.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6,
    cy: 5.75,
    fill: "#4C85FF",
    rx: 1.304,
    ry: 1.25
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 144.788,
    cy: 19.5,
    r: 1,
    fill: "#4379EC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.288,
    cy: 1,
    r: 1,
    fill: "#4C85FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.788,
    cy: 32.5,
    r: 1,
    fill: "#4C85FF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.04f4b47aba279b3f0779c048eb7ffd23.svg";
export { ForwardRef as ReactComponent };